import { ChangeDetectorRef, Component } from '@angular/core';
import {
  AccompanyingInfant,
  PassengerForServicingSeatmapScreen,
} from '@common/interfaces/servicing-seatmap/passenger-for-seatmap-screen';
import { SeatInfo, SeatInfoPassengers, SeatNumbers } from '@common/interfaces/servicing-seatmap/seat-info';
import {
  SeatForServicingSeatmapScreen,
  SeatForServicingSeatmapScreenBySegment,
} from '@common/interfaces/servicing-seatmap/seatmap-for-seatmap-screen';
import { AircraftCabin, AircraftCabinI18nJoinByAcvAndCabin } from '@common/master/aircraft-cabin-by-acv-and-cabin';
import { ServicingSeatmapStoreService } from '@common/services/seatmap/servicing-seatmap-store.service';
import { ServicingSeatmapLayoutDetailModalComponent } from '@common/components/seatmap-sub-components/servicing-seatmap-layout-detail-modal/servicing-seatmap-layout-detail-modal.component';
import { ServicingSeatmapSeatProductsModalComponent } from '@common/components/seatmap-sub-components/servicing-seatmap-seat-products-modal/servicing-seatmap-seat-products-modal.component';
import { LModalContentsWidthType, ModalType } from '@lib/components';
import { AswMasterService, CommonLibService, DialogDisplayService, ModalService, PageInitService } from '@lib/services';
import {
  GetOrderResponseData,
  GetSeatmapsResponse,
  GetSeatmapsResponseDataSeatmaps,
  GetSeatmapsResponseDataSeatmapsDecksInner,
  OrderSeatItemSeatSelection,
  Type1,
} from 'src/sdk-servicing';
import { ServicingSeatmapLegendsModalComponent } from '../seatmap-sub-components/servicing-seatmap-legends-modal/servicing-seatmap-legends-modal.component';
import { ServicingSeatmapPaidSeatDetailConfirmationComponent } from '../seatmap-sub-components/servicing-seatmap-paid-seat-detail-confirmation/servicing-seatmap-paid-seat-detail-confirmation.component';
import { ServicingBasePageComponent } from '../servicing-base-class';
import { MListData, PREVIOUS_PAGE_IDENTIFIER, ServicingFunctionIdType, ServicingPageIdType } from '@common/interfaces';
import { ChildSeats, UpdateSeatsChildSeatsInner } from '@common/interfaces/servicing-seatmap/child-seats';
import { AlertType, DialogClickType, DialogSize, DialogType, ErrorType, PageType } from '@lib/interfaces';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { ServicingSeatmapConfirmSeatReservationComponent } from '../seatmap-sub-components/servicing-seatmap-confirm-seat-reservation/servicing-seatmap-confirm-seat-reservation.component';
import { ServicingCommonStoreService } from '@common/services';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { LOAD_MASTERS, MASTER_KEY } from '@common/master/master';
import { SeatAvailability } from '@common/interfaces/servicing-seatmap/seat-availability';
import { MasterJsonKeyPrefix, MasterStoreKey } from '@conf/asw-master.config';
import { LangCodeConvertData } from '@common/master/lang-code-convert-by-lang';
import { GetOrderResponseDataPricesUnitPrices } from 'src/sdk-servicing/model/getOrderResponseDataPricesUnitPrices';
import { AirportI18nJoinByAirportCode } from '@common/master/airport-i18n-join-by-airport-code';
import { AirlineI18nJoinByAirlineCode } from '@common/master/airline-i18n-join-by-airline-code';
import { splitCouchSeatNumber } from '@common/helper';
import { MOfficeByOffceCode } from '@common/interfaces/master/office_by offce_code';
import { ServicingSeatmapService } from '@common/services/seatmap/servicing-seatmap.service';
import { SkipSegmentInfo } from '@common/interfaces/servicing-seatmap/skip-segment-info';
@Component({
  template: '',
})
export abstract class SeatmapBasePageComponent extends ServicingBasePageComponent {
  /** PNR情報 */
  pnrInfo: GetOrderResponseData | undefined;

  /** シートマップ再表示かどうか */
  isReDisplaySeatmap: boolean = false;

  /** セグメント表示対象 */
  displayTargetSegment?: Type1;

  /** 搭乗者IDリスト */
  passengerIdList: string[] = [];

  /** 空港情報 */
  airports?: AirportI18nJoinByAirportCode;

  /** 航空会社情報（コンテンツリンク付き） */
  airlines?: AirlineI18nJoinByAirlineCode;

  /** 座席情報マップ */
  seatInformationMap = new Map<string, SeatForServicingSeatmapScreen>();

  /** シートマップ */
  seatmapResponse?: GetSeatmapsResponse;

  /** 表示対象バウンド配列ID */
  displayTargetBoundArrayId: number = 0;

  /** 表示対象セグメントID */
  displayTargetSegmentId: string = '';

  /** 初期表示実施要否 */
  isRequiredInitDisplay: boolean = false;

  /** informativeかどうか */
  isInformative: boolean = false;

  /** 選択中座席情報リスト */
  selectedSeatInfoList?: SeatInfo[];

  /** 表示対象デッキ配列ID */
  displayTargetDeckArrayId: number = 0;

  /** 搭乗者情報マップ */
  travelersMap = new Map<string, PassengerForServicingSeatmapScreen>();

  /** キャビンクラス別機材情報 */
  aircraftCabins?: AircraftCabinI18nJoinByAcvAndCabin;

  /** キャビンクラス */
  cabinClasses?: MListData[];

  /** 表示対象セグメント配列ID */
  displayTargetSegmentArrayId: number = 0;

  /** 選択中の搭乗者ID */
  selectingPassengerId?: string = '';

  /** 選択中の座席ID */
  selectingSeatNumber?: string;

  /** 2階デッキが存在するか */
  isExistUpper = false;

  /** 1階デッキが存在するか */
  isExistMain = false;

  /** 初期表示デッキ */
  initialDeckType?: GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum;

  /** 機材情報 */
  aircraftCabin?: AircraftCabin;

  /** セグメント情報 */
  allSegmentInfo?: Array<Type1>;

  /** 全セグメント対象座席指定状況変更フラグ */
  isAllSegmentStateChange: boolean = false;

  /** 有料ASR席・カウチ席新規申込有無 */
  isPaidASRCouchNewApplicationAvailable: boolean = false;

  /** セグメント別座席指定状況変更フラグ */
  isSeatReservationStatusChangeBySegment: boolean = false;

  /** 最後の表示対象セグメントID */
  lastDisplayTargetSegmentId: string = '';

  /** 当画面内申込操作中かどうか */
  isOperationOnProgress: boolean = false;

  /** 最終セグメントかどうか */
  isLastSegment: boolean = false;

  /** 対象セグメント存在なしキャンセル済有料ASR席EMD有無 */
  isTargetSegmentASREMDAvailable: boolean = false;

  /** 対象セグメント存在なしキャンセル済カウチ席EMD有無 */
  isTargetSegmentCouchEMDAvailable: boolean = false;

  /** チャイルドシート申込数 */
  numberOfChildSeats: number = 0;

  /** チャイルドシート申込リスト */
  childSeatApplicationList?: ChildSeats[];

  /** チャイルドシート申込リスト(変更前) */
  originalChildSeatApplicationList?: ChildSeats[];

  /** カウチ席数 */
  numberOfCouchSeat: number = 0;

  /** 選択対象搭乗者配列ID */
  selectTargetPassengerArrayId?: number;

  /** 選択対象搭乗者ID */
  selectTargetPassengerId?: string;

  /** 変更前選択中座席情報 */
  selectedSeatBeforeChange?: SeatInfo;

  /** マスタ読み込みが完了したかのSubject */
  isMasterCallCompleted$ = new Subject<boolean>();

  /** タイムゾーン */
  timeZone?: string;

  /** Paypal利用可能フラグ */
  isPaypalAvailable: boolean = false;

  /** ブッキングクラス(シートマップ参照用) */
  informativeBookingClass?: string;

  constructor(
    private ____commonService: CommonLibService,
    private ___pageInitService: PageInitService,
    private __servicingSeatmapStoreService: ServicingSeatmapStoreService,
    private __modalService: ModalService,
    private __changeDetectorRef: ChangeDetectorRef,
    private __dialogService: DialogDisplayService,
    private __servicingCommonStoreService: ServicingCommonStoreService,
    private __router: Router,
    private __aswMasterService: AswMasterService,
    private __seatmapService: ServicingSeatmapService
  ) {
    super(____commonService, ___pageInitService);
  }

  override reload(): void {}

  override destroy(): void {}

  /**
   * 画面描画に必要なマスター情報を取得
   * seatmap-cont.component.ts にも同様のメソッドがあるため修正する際はそちらもあわせて修正を検討
   */
  protected subscribeGetMaster() {
    this.subscribeService(
      this.getMasters$(),
      ([airports, airlines, aircraftCabin, listDatas, langCodeConverts, mOfficeByOffceCode]: [
        AirportI18nJoinByAirportCode,
        AirlineI18nJoinByAirlineCode,
        any,
        Array<MListData>,
        any,
        MOfficeByOffceCode
      ]) => {
        this.airports = airports;
        this.airlines = airlines;
        this.aircraftCabins = aircraftCabin;
        const targetOfficeCode = this.____commonService?.aswContextStoreService?.aswContextData?.pointOfSaleId;
        if (!!targetOfficeCode) {
          this.isPaypalAvailable = mOfficeByOffceCode[targetOfficeCode][0]?.paypal_available_flag || false;
        }
        const lang = this.____commonService.aswContextStoreService.aswContextData.lang;
        let langCodeConvert = langCodeConverts.find(
          (langCodeConvert: any) => langCodeConvert.lang === lang
        ) as LangCodeConvertData;
        this.timeZone = listDatas.find(
          // 提携：タイムゾーン表記を日本時間のみに修正
          (data) => data.data_code === 'PD_113' && data.value === 'JP' && data.lang === lang
        )?.display_content;

        this.cabinClasses = listDatas?.filter((item) => item?.data_code === 'PD_930' && item?.lang === lang);

        this.isMasterCallCompleted$.next(true);
      }
    );
  }

  /**
   * 空港情報の取得
   * * seatmap-cont.component.ts にも同様のメソッドがあるため修正する際はそちらもあわせて修正を検討
   * @returns
   */
  private getMasters$(): Observable<any> {
    return this.__aswMasterService.load(
      [
        {
          key: LOAD_MASTERS.AIRPORT_I18NJOIN_BY_AIRPORT_CODE.key,
          fileName: LOAD_MASTERS.AIRPORT_I18NJOIN_BY_AIRPORT_CODE.fileName,
          isCurrentLang: true,
        },
        {
          key: LOAD_MASTERS.AIRLINE_I18NJOIN_BY_AIRLINE_CODE.key,
          fileName: LOAD_MASTERS.AIRLINE_I18NJOIN_BY_AIRLINE_CODE.fileName,
          isCurrentLang: true,
        },
        {
          key: MASTER_KEY.AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN,
          fileName: MASTER_KEY.AIRCRAFT_CABIN_I18NJOIN_ACV_AND_CABIN,
          isCurrentLang: true,
        },
        {
          key: MasterStoreKey.LISTDATA_ALL,
          fileName: MasterStoreKey.LISTDATA_ALL,
        },
        {
          key: MasterStoreKey.LANGCODECONVERT_ALL,
          fileName: MasterStoreKey.LANGCODECONVERT_ALL,
        },
        {
          key: LOAD_MASTERS.OFFICE_BY_OFFICE_CODE.key,
          fileName: LOAD_MASTERS.OFFICE_BY_OFFICE_CODE.fileName,
        },
      ],
      true
    );
  }

  /**
   * シートマップ再表示かどうかの設定
   */
  protected setReDisplayedSeatmap() {
    // 全画面共通の遷移元画面ID
    const previousPageIdentifier = this.__servicingCommonStoreService.servicingCommon.previousPageIdentifier;

    // 申し込み中フラグ
    const isApplicationProcessed =
      !!this.__servicingCommonStoreService.servicingCommon.seatReservationStatus?.isApplicationProcessed;

    // 遷移元IDがシートマップ系画面かどうか
    const isSeatmapPrePageId = Object.entries([
      PREVIOUS_PAGE_IDENTIFIER.SEATMAP,
      PREVIOUS_PAGE_IDENTIFIER.SEAT_ATTRIBUTE_REQUEST,
      PREVIOUS_PAGE_IDENTIFIER.INFORMATIVE_SEATMAP,
    ]).some((item) => item[1] === previousPageIdentifier);

    // シートマップ画面で使う遷移元判定IDがシートマップ系画面かどうか
    // 以下の条件を全て満たす場合
    // ・画面情報.機能ID=”S03”
    // ・画面情報.画面ID=”P010”、または画面情報.サブ画面ID=”P020”
    const isSeatmapFuncPageId =
      this.__servicingSeatmapStoreService.servicingSeatmap.functionId === ServicingFunctionIdType.SEATMAP &&
      (this.__servicingSeatmapStoreService.servicingSeatmap.pageId === ServicingPageIdType.SEATMAP ||
        this.__servicingSeatmapStoreService.servicingSeatmap.pageId === ServicingPageIdType.SEAT_ATTRIBUTE_REQUEST);

    // 座席変更中かどうか
    // 「座席指定状況、選択中座席情報リストが存在する、かつ、申込操作中かどうかフラグ=true」の場合
    const isSeatChangeProcess =
      !!this.__servicingCommonStoreService.servicingCommon.seatReservationStatus &&
      !!this.__servicingSeatmapStoreService.servicingSeatmap.selectedSeatInfoList &&
      this.__servicingSeatmapStoreService.servicingSeatmap.selectedSeatInfoList.length > 0 &&
      !!isApplicationProcessed;

    // 初回表示として扱うか
    // 「シート系画面以外から遷移、かつ、申し込み中フラグ=false」または、
    // 「シートマップ画面で使う遷移元判定IDがシートマップ系画面ではない」かつ、
    // 「座席変更中ではない」場合
    const isFirstDisplay =
      (!isSeatmapPrePageId && !isApplicationProcessed) || (!isSeatmapFuncPageId && !isSeatChangeProcess);

    // 1	以下の処理を行う。
    // 1.1	初回表示フラグ=falseの場合、再読み込みかどうかとしてtrue(自画面再読み込みである)を保持する。
    // 1.2	上記以外の場合、再読み込みかどうかとしてfalse(他画面からの遷移である)を保持する。
    //      servicingSeatmapの内容を破棄して、初めて遷移してきた時と同じ状態にする。
    if (!isFirstDisplay) {
      this.isReDisplaySeatmap = true;
    } else {
      let servicingSeatmap = {
        functionId: this.__servicingSeatmapStoreService.servicingSeatmap.functionId || '',
        pageId: this.__servicingSeatmapStoreService.servicingSeatmap.pageId || '',
      };
      this.__servicingSeatmapStoreService.setServicingSeatmap(servicingSeatmap);
    }

    // 他画面からの遷移である場合シートマップ遷移元画面識別子を設定
    if (this.isOtherScreenTransition(previousPageIdentifier)) {
      // ストアを更新する。
      this.__servicingSeatmapStoreService.updateServicingSeatmap({
        seatmapPreviousPageIdentifier: previousPageIdentifier,
        isFirstDisplayForSeatAttribute: isFirstDisplay,
      });
    } else {
      // ストアを更新する。
      this.__servicingSeatmapStoreService.updateServicingSeatmap({
        isFirstDisplayForSeatAttribute: isFirstDisplay,
      });
    }
  }

  /**
   * 他画面から遷移してきたか判定
   * @param previousPageIdentifier 遷移元画面識別子
   * @returns true：他画面から遷移 false：自画面から遷移
   */
  protected isOtherScreenTransition(previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER | undefined) {
    // 他画面から遷移した場合
    if (
      !!previousPageIdentifier &&
      previousPageIdentifier !== PREVIOUS_PAGE_IDENTIFIER.SEATMAP &&
      previousPageIdentifier !== PREVIOUS_PAGE_IDENTIFIER.SEAT_ATTRIBUTE_REQUEST
    ) {
      return true;
    }
    return false;
  }

  /**
   * 前画面情報引継ぎ処理
   */
  protected getInformationFromPreviousPage() {
    // [前画面情報引継ぎ処理]
    //  2.1	前画面より渡された項目を、以下に従い自画面の項目として保持する。
    this.displayTargetBoundArrayId =
      this.__servicingSeatmapStoreService.servicingSeatmap.displayTargetBoundArrayId || 0;
    this.displayTargetSegmentArrayId =
      this.__servicingSeatmapStoreService.servicingSeatmap.displayTargetSegmentArrayId || 0;
    this.displayTargetSegmentId = this.__servicingCommonStoreService.servicingCommon.displayTargetSegmentId || '';
    this.lastDisplayTargetSegmentId =
      this.__servicingSeatmapStoreService.servicingSeatmap.lastDisplayTargetSegmentId || '';
    this.isRequiredInitDisplay = this.__servicingSeatmapStoreService.servicingSeatmap.isRequiredInitDisplay || false;
    this.isOperationOnProgress = this.__servicingSeatmapStoreService.servicingSeatmap.isOperationOnProgress || false;
    this.isLastSegment = this.__servicingSeatmapStoreService.servicingSeatmap.isLastSegment || false;
    this.isTargetSegmentASREMDAvailable =
      this.__servicingSeatmapStoreService.servicingSeatmap.isTargetSegmentASREMDAvailable || false;
    this.isTargetSegmentCouchEMDAvailable =
      this.__servicingSeatmapStoreService.servicingSeatmap.isTargetSegmentCouchEMDAvailable || false;
    this.isPaidASRCouchNewApplicationAvailable =
      this.__servicingSeatmapStoreService.servicingSeatmap.isPaidASRCouchNewApplicationAvailable || false;
    this.isInformative = this.__servicingSeatmapStoreService.servicingSeatmap.isInformative || false;
    this.selectedSeatInfoList = this.__servicingSeatmapStoreService.servicingSeatmap.selectedSeatInfoList || undefined;
    if (this.selectedSeatInfoList) {
      let tempNoOfChildSeats = this.selectedSeatInfoList?.find(
        (s) => s.segmentId === this.displayTargetSegmentId
      )?.numberOfChildSeats;
      this.numberOfChildSeats = !!tempNoOfChildSeats ? tempNoOfChildSeats : 0;
    }

    this.childSeatApplicationList = this.__servicingSeatmapStoreService.servicingSeatmap.childSeatAppliedList || [];
    this.originalChildSeatApplicationList =
      this.__servicingSeatmapStoreService.servicingSeatmap.originalChildSeatApplicationList || [];
    this.isAllSegmentStateChange =
      this.__servicingSeatmapStoreService.servicingSeatmap.isAllSegmentStateChange || false;
    this.numberOfCouchSeat = this.__servicingSeatmapStoreService.servicingSeatmap.numberOfCouchSeat || 0;

    //  2.2	以下の項目を初期化する。
    //   2.2.1	表示対象デッキ配列IDに0を設定する
    this.displayTargetDeckArrayId = 0;
    //   2.2.2	選択対象搭乗者配列IDに0を設定する
    this.selectTargetPassengerArrayId = 0;
    //   2.2.3	選択対象搭乗者IDに""(空欄)を設定する。
    this.selectTargetPassengerId = '';
    // [前画面情報引継ぎ処理]
  }

  /**
   *  画面内変数の初期化処理
   */
  protected initVariables() {
    // 3.1 画面表示に関する項目について、以下の内容で初期化する。
    this.displayTargetBoundArrayId = 0;
    this.displayTargetSegmentArrayId = 0;
    this.displayTargetSegmentId = this.__servicingCommonStoreService.servicingCommon.displayTargetSegmentId || '';
    this.displayTargetDeckArrayId = 0;
    this.selectTargetPassengerArrayId = 0;
    this.selectTargetPassengerId = '';

    // 3.2	画面内の各処理にて使用する値について、以下の内容で初期化する。
    this.isRequiredInitDisplay = true;
    this.isOperationOnProgress = false;
    this.isLastSegment = false;
    this.isTargetSegmentASREMDAvailable = false;
    this.isTargetSegmentCouchEMDAvailable = false;
    this.isPaidASRCouchNewApplicationAvailable = false;
    this.isInformative = false;
    this.isAllSegmentStateChange = false;
    this.isSeatReservationStatusChangeBySegment = false;

    // 3.5	選択中のセグメント情報を保持するために、以下の二つの配列を作成する。値は表の内容に従う。
    //   3.5.1	選択中座席情報リスト
    this.selectedSeatInfoList = [];

    this.childSeatApplicationList = [];
    this.originalChildSeatApplicationList = [];
    let childSeatApplicationList: ChildSeats[] = [];

    this.pnrInfo?.air?.bounds?.forEach((bound) => {
      bound.flights?.forEach((flight) => {
        let passengerList: SeatInfoPassengers[] = [];

        this.pnrInfo?.travelers?.forEach((traveler) => {
          if (!!flight.id && !!traveler.id) {
            let seatNumber: string[] = [];
            let tempPassengerSeat = !!this.pnrInfo?.seats?.[flight.id]
              ? this.pnrInfo?.seats?.[flight.id][traveler.id]
              : undefined;
            let tempSeatNo = '';
            let price = undefined;

            if (!!tempPassengerSeat) {
              if (!!tempPassengerSeat.seatSelection) {
                tempSeatNo = tempPassengerSeat.seatSelection.couchSeatNumber;
                seatNumber = tempPassengerSeat.seatSelection.seatNumbers;
              }

              const tmpUnitPrice = this.pnrInfo?.prices?.unitPrices as GetOrderResponseDataPricesUnitPrices;
              if (tempPassengerSeat.seatSelection.isCouchRepresentative) {
                price = tmpUnitPrice?.[traveler.id || '']?.servicePrices?.couch[0]?.value;
                seatNumber = [];
                let couchSeatSplit = splitCouchSeatNumber(tempSeatNo);
                let couchSeatNo =
                  couchSeatSplit && couchSeatSplit.columnNumbers && couchSeatSplit.columnNumbers?.length > 0
                    ? couchSeatSplit.rowNumber + couchSeatSplit.columnNumbers[0]
                    : '';
                seatNumber.push(couchSeatNo);
              } else if (tempPassengerSeat.seatSelection.isChargeable) {
                price = tmpUnitPrice?.[traveler.id || '']?.servicePrices?.chargeableSeatRequest[0]?.value;
              }
              price = price || 0;

              passengerList.push({
                id: traveler.id || '',
                seatNumberList: seatNumber.length > 0 ? [{ seatNumber: seatNumber[0] }] : [],
                couchSeatNumberList: [{ seatNumber: tempSeatNo }],
                ssrInformation: undefined,
                specifiedAmount: tempPassengerSeat.seatSelection.serviceStatus === 'confirmed' ? 0 : price,
                hasBassinetAttribute: tempPassengerSeat.bassinet,
                isChildSeatSelectable: tempPassengerSeat.childSeat,
              });

              // チャイルドシート申込済の場合
              if (tempPassengerSeat.childSeat) {
                // チャイルドシートの選択対象となる搭乗者情報の抽出の場合
                if (
                  traveler.passengerTypeCode === 'CHD' ||
                  traveler.passengerTypeCode === 'INS' ||
                  (traveler.passengerTypeCode === 'ADT' && !!traveler.hasNamelessInfant)
                ) {
                  childSeatApplicationList.push({
                    updateCategory: UpdateSeatsChildSeatsInner.OperationEnum.Request,
                    passengerId: traveler.id,
                    childSeatType: tempPassengerSeat.childSeatType || '',
                  });
                }
              }
            }
          }
        });

        if (!!this.selectedSeatInfoList) {
          this.selectedSeatInfoList.push({
            passengerList: passengerList,
            segmentId: flight.id || '',
            characteristicRequestSsrCode: '', // 座席属性はSSR登録済みの値を設定しない。セグ単位で保持する変更した場合の値として扱う。
          });
        }

        // チャイルドシート申込リスト(変更前、編集用)の設定
        if (this.childSeatApplicationList?.length == 0) {
          this.childSeatApplicationList = childSeatApplicationList.concat();
          this.originalChildSeatApplicationList = childSeatApplicationList.concat();
        }
      });
    });

    // ストアを更新する。
    this.__servicingSeatmapStoreService.updateServicingSeatmap({
      isInformative: this.isInformative,
    });
  }

  /**
   * 表示するセグメントを設定する
   * 1. PNR情報取得より、シートマップの利用可否が利用不可である場合、スキップ処理を行う。
   * 2. 上記以外の場合、全セグメントのシートマップ表示判定処理フラグ = trueとし、表示するセグメントを設定する。
   * @returns 判定結果 true: 全セグメントのシートマップ表示可 false: 全セグメントのシートマップ表示不可
   */
  protected _determineDisplaySeatmap() {
    // 全セグメントのシートマップ表示判定処理フラグを作成し、 false を設定する。
    let isSkipAllSegmentDecisionProces = false;
    // バウンドインデックスを作成し、0 を設定する。
    let boundIndex = 0;

    // セグメント情報に空のリストを設定する。
    this.allSegmentInfo = [];
    // ＜以下、PNR情報.data.air.boundsの要素分、繰り返し＞
    // ＜以下、当該bounds.flightsの要素分、繰り返し＞
    this.pnrInfo?.air?.bounds?.forEach((b) => {
      b.flights?.forEach((f) => {
        // セグメント情報に当該flights を追加する。
        this.allSegmentInfo?.push(f);
      });
    });
    // ＜ここまで、当該bounds.flightsの要素分、繰り返し＞
    // ＜ここまで、PNR情報.data.air.boundsの要素分、繰り返し＞
    // PNR情報.data.air.boundsが存在する場合、以下の処理を行う。
    if (!!this.pnrInfo?.air?.bounds) {
      // ＜以下、PNR情報.data.air.boundsの要素分、繰り返し＞
      for (let bound of this.pnrInfo?.air?.bounds) {
        // 全セグメントのシートマップ表示判定処理フラグが true の場合
        // ループ処理を終了する。
        if (isSkipAllSegmentDecisionProces) {
          break;
        }

        // セグメントインデックスを作成し、0 を設定する。
        let flightIndex = 0;

        // 6.18	当該bounds.flightsが存在する場合以下の処理を行う。
        if (!!bound?.flights) {
          // ＜以下、当該bounds.flightsの要素分、繰り返し＞
          for (let flight of bound?.flights) {
            // 全セグメントのシートマップ表示判定処理フラグが true の場合
            // ループ処理を終了する。
            if (isSkipAllSegmentDecisionProces) {
              break;
            }
            // 表示対象セグメントIDが存在する場合、以下の処理を行う。
            if (!!this.displayTargetSegmentId) {
              // 表示対象セグメントインデックスを作成し、 当該bounds.flights の id が表示対象セグメントID と一致するインデックスを設定する。
              let segmentIndex = bound.flights?.findIndex((f) => f.id === this.displayTargetSegmentId);
              // 表示対象セグメントインデックス < 0 の場合
              // ループ処理を終了する。
              if (segmentIndex < 0) {
                break;
              }
              // セグメントインデックス < 表示対象セグメントインデックスの場合
              // セグメントインデックスをインクリメントする。
              // ループを次の flights に移動する。
              if (flightIndex < segmentIndex) {
                ++flightIndex;
                continue;
              }
            }

            // PNR情報.data.orderEligibilities.seatmap.[当該flights.id].isEligible が false の場合
            if (this.pnrInfo?.orderEligibilities?.seatmap?.[flight.id || ''].isEligible === false) {
              // 以下のセグメントスキップ処理を行う。
              this.segmentSkip();
              return false;
            } else {
              // 上記以外の場合、以下の処理を行う。

              // 表示対象バウンド配列IDに、バウンドインデックスを設定する。
              this.displayTargetBoundArrayId = boundIndex;
              // 表示対象セグメント配列IDに、セグメントインデックスを設定する。
              this.displayTargetSegmentArrayId = flightIndex;
              // 表示対象セグメントIDに当該flights.idを設定する。
              this.displayTargetSegmentId = flight.id || '';
              // シートマップ情報に undefined を設定する。
              // ※シートマップの破棄
              this.seatmapResponse = undefined;
              // 全セグメントのシートマップ表示判定処理を終了する。
              isSkipAllSegmentDecisionProces = true;
            }
            // セグメントインデックスをインクリメントする
            ++flightIndex;
          }
          // ＜ここまで、当該bounds.flightsの要素分、繰り返し＞
        }
        // バウンドインデックスをインクリメントする。
        ++boundIndex;
      }
      // ＜ここまで、PNR情報.data.air.boundsの要素分、繰り返し＞
    }

    return true;
  }

  /*
   * 9 画面表示処理を呼び出す。
   * [以下、画面表示処理]
   */
  protected setDisplayContents() {
    //  10 表示対象データ作成処理を呼び出す。
    // [以下、表示対象データ作成処理]
    this.setDisplayTarget();

    //  11 セグメント情報コンポーネント呼び出し処理として、以下の処理を行う。
    this.setSegmentComponent();

    //  12 指定状況詳細(当該セグメント)コンポーネント呼び出し処理として、以下の処理を行う。
    this.setAssignmentStatusComponent();

    //  14 凡例コンポーネント呼び出し処理として、以下の処理を行う。
    this.setLegendComponent();
  }

  /**
   * 表示データ作成処理
   */
  private setDisplayTarget() {
    let ssrSeatNumberMap = new Map<string, string[]>();

    // 10.6	初期表示実施要否=trueかつinformativeかどうか=falseの場合、以下の処理を実施する。
    if (!!this.isRequiredInitDisplay && !this.isInformative) {
      // ＜以下、PNR情報.data.travelers(以下、搭乗者情報リスト)の要素数分、繰り返し＞
      if (!!this.pnrInfo?.travelers) {
        this.pnrInfo.travelers.forEach((traveler) => {
          if (!!traveler.id) {
            // チャイルドシート申込中フラグ
            let childSeatType = this.childSeatApplicationList?.find(
              (childSeat) => childSeat.passengerId === traveler.id
            )?.childSeatType;
            let isRequestChildSeat = childSeatType ? true : false;

            // 10.6.1	搭乗者情報リスト.当該passengerTypeCode≠"INF"の場合、以下の処理を行う。
            if ((traveler.passengerTypeCode as string) !== 'INF') {
              // 10.6.1.1	搭乗者IDリストに搭乗者情報リスト.当該idを追加する。
              if (!this.passengerIdList.find((passengerId) => passengerId === traveler.id)) {
                this.passengerIdList.push(traveler.id);
              }

              // 10.6.1.2	搭乗者情報として以下の項目を作成し、搭乗者情報リスト.当該idをキーに搭乗者情報マップを更新する。
              //          ※該当idをキーとした搭乗者マップの要素が存在しない場合、追加する。

              //座席番号：
              //    表示対象セグメントID、搭乗者情報リスト.当該idに紐づくPNR情報.data.seats.＜表示対象セグメントID＞.
              //    ＜当該orderSeatItems＞.seatSelection.seatNumbers[0]
              let tempSeatNo =
                this.pnrInfo?.seats?.[this.displayTargetSegmentId]?.[traveler.id]?.seatSelection.seatNumbers[0];
              let tempCouchSeatNumber = '';
              if (!!this.pnrInfo?.seats?.[this.displayTargetSegmentId]?.[traveler.id]?.seatSelection.couchSeatNumber) {
                tempCouchSeatNumber =
                  this.pnrInfo?.seats?.[this.displayTargetSegmentId]?.[traveler.id]?.seatSelection.couchSeatNumber;
              }

              //搭乗者情報マップ作成処理
              this.travelersMap.set(traveler.id, {
                name:
                  traveler.names?.[0].title + ' ' + traveler.names?.[0].firstName + ' ' + traveler.names?.[0].lastName,
                passengerTypeCode: traveler.passengerTypeCode,
                accompanyingInfant: undefined,
                hasInfiniNamelessInfant: traveler.hasInfiniNamelessInfant,
                hasNamelessInfant: traveler.hasNamelessInfant,
                seatNumber: tempSeatNo,
                couchSeatNumber: tempCouchSeatNumber,
                isRequestChildSeat: isRequestChildSeat,
                isRequestBassinet: this.pnrInfo?.seats?.[this.displayTargetSegmentId]?.[traveler.id]?.bassinet,
                sequence: this.travelersMap.size + 1,
              });

              // 10.6.2	上記以外の場合、同伴幼児情報設定処理として以下の処理を行う。
            } else {
              // 10.6.2.1	同伴幼児情報として以下の項目を作成する。
              let accompanyingInfant: AccompanyingInfant = {
                id: traveler.id,
                name:
                  traveler.names?.[0].title + ' ' + traveler.names?.[0].firstName + ' ' + traveler.names?.[0].lastName,
              };

              // 10.6.2.2	搭乗者情報.accompanyingTravelerIdをキーに取得した搭乗者情報マップ.当該同伴幼児情報に、同伴幼児情報を設定する。
              let accompanyingTravelerId = traveler.accompanyingTravelerId;
              if (!!accompanyingTravelerId) {
                let tempPassenger = this.travelersMap.get(accompanyingTravelerId);
                if (tempPassenger) {
                  this.travelersMap.set(accompanyingTravelerId, {
                    ...tempPassenger,
                    accompanyingInfant: accompanyingInfant,
                  });
                }
              }
            }
          }
        });
      } // ＜ここまで、搭乗者情報リストの要素数分、繰り返し＞

      // informativeかどうか=falseの場合、チャイルドシート申込数を設定
      if (!this.isInformative) {
        this.numberOfChildSeats = 0;
        this.travelersMap.forEach((passenger, id) => {
          if (passenger.isRequestChildSeat) {
            this.numberOfChildSeats++;
          }

          if (!!passenger.couchSeatNumber) {
            // 登録済みのカウチ座席番号を分解して登録済み座席番号一覧に設定
            const { rowNumber, columnNumbers } = splitCouchSeatNumber(passenger.couchSeatNumber);
            if (!!rowNumber && !!columnNumbers) {
              for (const columnNumber of columnNumbers) {
                const couchSeatStartNumber = `${rowNumber}${columnNumber}`;
                let passengers = ssrSeatNumberMap.get(couchSeatStartNumber) || [];
                passengers.push(id);
                ssrSeatNumberMap.set(couchSeatStartNumber, passengers);
              }
            }
          } else if (!!passenger.seatNumber) {
            // 登録済みの座席番号を登録済み座席番号一覧に設定
            let passengers = ssrSeatNumberMap.get(passenger.seatNumber) || [];
            passengers.push(id);
            ssrSeatNumberMap.set(passenger.seatNumber, passengers);
          }
        });
      }
    }

    // 基本的には発生しない想定だが、何らかの理由で前提となる値が存在しない場合は処理終了とする。
    if (!this.seatmapResponse) {
      return;
    }

    for (let i = 0; i < this.seatmapResponse?.data.seatmaps.decks.length; i++) {
      // ＜以下、シートマップ情報.data.seatmaps.decks[表示対象デッキ配列ID].seats.rows(以下、行情報とする)の要素数分、繰り返し＞
      this.seatmapResponse?.data.seatmaps.decks[i].seats.rows.forEach((row, rowIndex) => {
        // 10.2	値が""(空欄)のカウチ座席番号リストを作成する。
        // 10.3	値が0である表示済み通路カウントを作成する。
        let couchList: Array<string> = [];
        let displayedAisleCount: number = 0;

        // ＜以下、行情報.columns(以下、列情報とする)の要素数分、繰り返し＞
        if (row.rowType === 'seat') {
          row.columns.forEach((column, columnIndex) => {
            if (!!column) {
              // 英数字混合から列の英字のみを抽出 例)34B→B
              let columnNumber = !!column.seatNumber ? column.seatNumber.replace(/[^0-9]/g, '') : '';

              if (column.columnType === 'aisle') {
                displayedAisleCount += 1;
              }

              // ブロック情報
              // 行情報.numberOfAisle=2の場合
              //  1	表示済み通路カウント=0の場合、”left”
              //  2	表示済み通路カウント=1の場合、”center”
              //  3	表示済み通路カウント=2の場合、”right”
              // 上記以外の場合
              //  1	表示済み通路カウント=0の場合、”left”
              //  2	表示済み通路カウント=1の場合、”right”
              let blockInformation;
              if (this.seatmapResponse?.data.seatmaps.decks[i].numberOfAisle === 2) {
                switch (displayedAisleCount) {
                  case 0:
                    blockInformation = 'left';
                    break;
                  case 1:
                    blockInformation = 'center';
                    break;
                  case 2:
                    blockInformation = 'right';
                    break;
                  default:
                    break;
                }
              } else {
                switch (displayedAisleCount) {
                  case 0:
                    blockInformation = 'left';
                    break;
                  case 1:
                    blockInformation = 'right';
                    break;
                  default:
                    break;
                }
              }

              // 登録済搭乗者ID,選択中搭乗者ID
              // informativeかどうか=falseの場合
              // registedPassengerID: 列情報.seatNumber=PNR情報.seats.表示対象セグメントID(以降、登録済み座席情報とする).orderSeatItems.seatSelection.seatNumberである登録済み座席情報.orderSeatItemsのキー
              // selectingPassengerID: 選択中座席情報リスト≠""(空欄)の場合、列情報.seatNumber=選択中座席情報.当該選択している座席情報.座席番号リスト.座席番号である選択中座席情報.当該搭乗者ID
              // 上記以外の場合はどちらも""(空欄)
              let registedPassengerId = '';
              let selectingPassengerId = '';
              if (!this.isInformative) {
                for (let passengerId of this.passengerIdList) {
                  registedPassengerId = this.pnrInfo?.seats?.[this.displayTargetSegmentId]?.[
                    passengerId
                  ].seatSelection.seatNumbers.includes(column.seatNumber)
                    ? passengerId
                    : '';

                  if (!!registedPassengerId) {
                    break;
                  }
                }

                let targetSegments = this.selectedSeatInfoList?.find(
                  (s) => s.segmentId === this.displayTargetSegmentId
                );
                if (!!targetSegments?.passengerList) {
                  for (let targetPassenger of targetSegments?.passengerList) {
                    if (!selectingPassengerId && !!targetPassenger.seatNumberList) {
                      for (let num of targetPassenger.seatNumberList) {
                        if (num.seatNumber === column.seatNumber) {
                          selectingPassengerId = targetPassenger.id;
                          break;
                        }
                      }
                    }
                  }
                }
              }

              // 10.5	座席情報マップ作成処理として、以下の処理を行う。
              // 10.5.1	以下の内容で座席情報を作成し、列情報.当該seatNumberをキーとして座席情報マップに追加する。
              this.seatInformationMap.set(column.seatNumber, {
                rowNumber: row.rowNumber,
                rowArrayID: rowIndex,
                columnNumber: columnNumber,
                columnArrayID: columnIndex,
                couchNumber: '',
                seatCharacteristicsCodes: column.seatCharacteristicsCodes,
                blockInformation: blockInformation,
                isChargeableAsrSeat: column.isChargeableAsrSeat,
                isCouchSeat: column.isCouchSeat,
                isRearDirectionSeat: !!column.seatCharacteristicsCodes
                  ? column.seatCharacteristicsCodes.includes('J')
                  : undefined,
                isChildSeatAttachable: column.isChildSeatAttachable,
                registedPassengerID: registedPassengerId,
                selectingPassengerID: selectingPassengerId,
                prices: column.prices,
                travelers: column.travelers?.map((traveler) => {
                  if (!!traveler.id) {
                    let isClickable = !this.seatmapResponse?.data.travelersSummary.isChangeRestrictedAllSeat;

                    let passengers = this.selectedSeatInfoList?.find(
                      (s) => s.segmentId === this.displayTargetSegmentId
                    )?.passengerList;
                    if (isClickable && !!passengers) {
                      let tempPassengerId = passengers.find((p) =>
                        p.seatNumberList?.find((s) => s.seatNumber === column.seatNumber)
                      )?.id;
                      let ssrSeatPassengerIds = ssrSeatNumberMap.get(column.seatNumber);
                      if (!!ssrSeatPassengerIds && ssrSeatPassengerIds.length > 0) {
                        // 当該搭乗者が登録済みの座席の場合(カウチ席の場合は全席)、押下可否に true を設定
                        isClickable = ssrSeatPassengerIds.includes(traveler.id);
                      } else if (!!tempPassengerId && !column.isCouchSeat) {
                        // カウチ以外かつ当該搭乗者が選択状態の座席の場合、押下可否に true を設定
                        // 未登録のカウチ席の場合は搭乗者の選択状態にかかわらず選択可能のため
                        isClickable = tempPassengerId === traveler.id;
                      }
                    }

                    return {
                      id: traveler.id,
                      seatAvailabilityStatus: traveler.seatAvailabilityStatus,
                      isClickable: isClickable,
                      prices: traveler.prices,
                      isExempted: traveler.isExempted,
                    } as SeatAvailability;
                  } else {
                    return {
                      id: traveler.id,
                      seatAvailabilityStatus: traveler.seatAvailabilityStatus,
                      isClickable: false,
                      prices: traveler.prices,
                      isExempted: traveler.isExempted,
                    } as SeatAvailability;
                  }
                }),
                deckType: this.seatmapResponse?.data.seatmaps.decks[i].deckType,
              });

              // 10.5.2	ブロック開始列フラグにfalseを設定する。
              // 10.5.3	ブロック終了列フラグにfalseを設定する。
              let isBlockStartColumn: boolean = false;
              let isBlockEndColumn: boolean = false;
              // 10.5.4	列情報.当該columnType="seat"
              if (column.columnType === 'seat') {
                // 10.5.4.1	以下の条件全てを満たす場合、ブロック開始列フラグにtrueを設定する。
                // 10.5.4.2	列情報.当該要素番号=0、または列情報.前columnType="aisle"
                if (columnIndex === 0 || row.columns[columnIndex - 1].columnType === 'aisle') {
                  isBlockStartColumn = true;
                }
                // 10.5.4.3	以下の条件を全て満たす場合、ブロック終了列フラグにtrueを設定する。
                // 10.5.4.4	列情報.当該要素番号=列情報の要素数-1、または列情報.次columnType="aisle"
                if (columnIndex === row.columns.length - 1 || row.columns[columnIndex + 1].columnType === 'aisle') {
                  isBlockEndColumn = true;
                }
              }
              // 10.5.5	列情報.isCouchSeatの場合、カウチ席番号を作成する。
              if (column.isCouchSeat) {
                // 10.5.5.1	ブロック開始列フラグ=trueの場合、以下の内容を設定する。
                if (isBlockStartColumn) {
                  // 10.5.5.1.1	カウチ座席番号リストに""(空欄)を設定する。
                  couchList = [];
                }
                // 10.5.5.3	カウチ座席番号リストに列情報.当該seatNumberを追加する。
                couchList.push(column.seatNumber); //{5A, 5B}

                // 10.5.5.4	ブロック終了列フラグ=trueの場合、以下の処理を行う。
                if (isBlockEndColumn) {
                  // ＜以下、カウチ座席番号リストの要素数分、繰り返し＞
                  // 10.5.5.4.1	カウチ座席番号リスト.当該座席番号をキーに取得した座席情報マップ.当該カウチ席番号に、カウチ席番号を設定する。
                  for (const couchId of couchList) {
                    const seat = this.seatInformationMap.get(couchId);
                    if (!!seat) {
                      this.updateSeatInformation(this.seatInformationMap, couchId, seat, {
                        couchNumber: this.setCouchSeat(couchList),
                      });
                    }
                  } // ＜ここまでカウチ座席番号リストの要素数分、繰り返し＞
                }
              }
            }
          }); // ＜ここまで、列情報の要素数分、繰り返し＞
        }
      }); // ＜ここまで、行情報の要素数分、繰り返し＞
    }
  } // [ここまで、表示対象データ作成処理]

  // 11	セグメント情報コンポーネント呼び出し処理として、以下の処理を行う。
  private setSegmentComponent() {
    // 11.1	以下の値を子コンポーネントへのパラメータとして設定し、セグメント情報コンポーネントを呼び出す。
    // informativeかどうか=trueの場合
    // 表示対象セグメント情報：シートマップ情報.data.seatmapFlight
    if (this.isInformative) {
      this.displayTargetSegment = this.seatmapResponse?.data.seatmapFlight;
    } else {
      // 表示対象セグメント情報：PNR情報.air.bounds[表示対象バウンド配列ID].flights[表示対象セグメント配列ID]
      this.displayTargetSegment =
        this.pnrInfo?.air?.bounds?.[this.displayTargetBoundArrayId].flights?.[this.displayTargetSegmentArrayId];
    }
  }

  // 12 指定状況詳細(当該セグメント)コンポーネント呼び出し処理として、以下の処理を行う。
  private setAssignmentStatusComponent() {
    // 12.1	informativeかどうか = falseの場合、選択中搭乗者ID設定処理として、以下の処理を行う。
    if (this.isInformative) {
      return;
    }

    // 座席を未選択の搭乗者のIDを探す（INFを除外した最初に該当するID）　※搭乗者IDリストはINFを除外した状態
    this.selectingPassengerId = this.selectedSeatInfoList
      ?.find((s) => s.segmentId === this.displayTargetSegmentId)
      ?.passengerList.filter((p) => this.passengerIdList.some((pid) => pid === p.id))
      ?.find(
        (p) => !p.seatNumberList || p.seatNumberList.length === 0 || p.seatNumberList.every((n) => !n.seatNumber)
      )?.id;

    // 選択対象搭乗者IDが存在しない場合、選択中搭乗者IDにPNR情報.data.travelers[0].当該idを設定する。
    if (!this.selectingPassengerId) {
      this.selectingPassengerId = this.pnrInfo?.travelers?.[0].id;
    }

    // 12.2	指定状況詳細(当該セグメント)コンポーネントを呼び出す。
    // NOP
  }

  /**
   * 14 凡例コンポーネントの呼び出し処理
   */
  private setLegendComponent() {
    const madeData = this.makeSeatInformationMap(this.displayTargetSegment, this.seatmapResponse?.data.seatmaps);

    // 画面項目表示用変数の初期化処理
    this.isExistUpper = madeData.isExistUpper;
    this.isExistMain = madeData.isExistMain;
    this.initialDeckType = madeData.initialDeckType;
    this.aircraftCabin = madeData.aircraftCabin;

    // 表示対象デッキ配列IDの設定
    this.initDisplayTargetDeckArrayId(this.initialDeckType);

    // ストアを更新する。
    this.__servicingSeatmapStoreService.updateServicingSeatmap({
      passengers: Object.fromEntries(this.travelersMap),
      passengerList: this.passengerIdList,
      segments: this.allSegmentInfo,
      selectedSeatInfoList: this.selectedSeatInfoList,
      pnrInfo: this.pnrInfo,
      seatmap: Object.fromEntries(this.seatInformationMap),
      seatNumber: '',
      selectingPassengerId: this.selectingPassengerId,
      seatmapInfo: this.seatmapResponse,
      displayTargetBoundArrayId: this.displayTargetBoundArrayId,
      displayTargetSegmentArrayId: this.displayTargetSegmentArrayId,
      defaultSeatmapInfoBySegmentList: this._getDefaultSeatmapInfoBySegment(),
    });

    this.__servicingCommonStoreService.updateServicingCommon({
      displayTargetSegmentId: this.displayTargetSegmentId,
    });
  }

  /**
   * 座席情報マップ生成共通処理：表示用座席情報マップを作成する
   * @param segment 表示対象セグメント情報
   * @param seatmapResponse シートマップ取得結果
   * @returns 初期表示デッキ、1階デッキが存在するか、2階デッキが存在するか、機材情報
   */
  private makeSeatInformationMap(
    segment: Type1 | undefined,
    seatmapResponse: GetSeatmapsResponseDataSeatmaps | undefined
  ) {
    const decks = seatmapResponse?.decks || [];

    // 2階デッキが存在するかどうか。あれば表示階切替タブを表示する。
    const isExistUpper = decks.some((deck) => deck.deckType === 'upper');
    // 1階デッキが存在するかどうか。存在しなければ表示階切替タブの初期表示を2階にし、「1階タブ」を非活性とする。
    const isExistMain = decks.some((deck) => deck.deckType === 'main');
    let initialDeckType;

    if (isExistUpper) {
      // 2階デッキが存在する場合、座席選択中の搭乗者がすべて2階席を選択しているかどうか判定する
      // 選択中の座席は未登録も含めて判定できるように「選択中座席情報リスト」を参照する

      // 座席選択中の搭乗者リスト
      const selectedPassengerList = this.selectedSeatInfoList
        ?.find((seat) => seat.segmentId === this.displayTargetSegmentId)
        ?.passengerList.filter((p) => !!this.__seatmapService.getSeatNumberForSeatNumberList(p.seatNumberList));

      // 座席選択中の搭乗者が全て2階を選択しているかどうか
      const isSeatSelectedAllUpper =
        !!selectedPassengerList &&
        selectedPassengerList.length > 0 &&
        !!selectedPassengerList?.every((passenger) => {
          const selectedSeatNumber = this.__seatmapService.getSeatNumberForSeatNumberList(passenger.seatNumberList);
          return (
            !!selectedSeatNumber &&
            this.seatInformationMap?.get(selectedSeatNumber)?.deckType ===
              GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum.Upper
          );
        });

      // 「全搭乗者が2階席を選択、または、mainデッキが存在しない」場合、初期表示デッキはupper
      // 「それ以外」の場合、初期表示デッキはmain
      initialDeckType =
        isSeatSelectedAllUpper || !isExistMain
          ? GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum.Upper
          : GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum.Main;
    } else {
      // このフローではmainのみ設定される想定となる（upperが存在しない = mainのみ）
      initialDeckType = GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum.Main;
    }

    // キャビンクラス別機材情報の設定
    let aircraftCabin;
    if (!!segment && !!segment.aircraftConfigurationVersion && !!segment.cabin) {
      const cabinName = segment.cabin;
      aircraftCabin = this.aircraftCabins?.[segment.aircraftConfigurationVersion]?.[cabinName]?.[0];
    }

    return { isExistUpper, initialDeckType, aircraftCabin, isExistMain };
  }

  /**
   * 座席情報マップの特定のキーの、特定のデータを更新する。
   *
   * 値を更新する例として isCouchSeat のみを更新したい場合は、下記のupdateValueを設定する
   * `{isCouchSeat: false}`
   *
   * また注意点として、updateValue に null や undefined のデータが存在していれば上書きされる。
   * 具体的には、`{isCouchSeat: false}` の場合は、 seatCharacteristicsCodes の値は変更されないが、
   * `{seatCharacteristicsCodes: null}` の場合は、 seatCharacteristicsCodes を null で更新する。
   */
  private updateSeatInformation(
    map: Map<string, SeatForServicingSeatmapScreen>,
    key: string,
    originValue: SeatForServicingSeatmapScreen,
    updateValue: SeatForServicingSeatmapScreen
  ) {
    map.set(key, {
      rowNumber: updateValue.rowNumber || originValue.rowNumber,
      rowArrayID: updateValue.rowArrayID || originValue.rowArrayID,
      columnNumber: updateValue.columnNumber || originValue.columnNumber,
      columnArrayID: updateValue.columnArrayID || originValue.columnArrayID,
      couchNumber: updateValue.couchNumber || originValue.couchNumber,
      seatCharacteristicsCodes: updateValue.seatCharacteristicsCodes || originValue.seatCharacteristicsCodes,
      blockInformation: updateValue.blockInformation || originValue.blockInformation,
      isChargeableAsrSeat: updateValue.isChargeableAsrSeat || originValue.isChargeableAsrSeat,
      isCouchSeat: updateValue.isCouchSeat || originValue.isCouchSeat,
      isRearDirectionSeat: updateValue.isRearDirectionSeat || originValue.isRearDirectionSeat,
      isChildSeatAttachable: updateValue.isChildSeatAttachable || originValue.isChildSeatAttachable,
      registedPassengerID: updateValue.registedPassengerID || originValue.registedPassengerID,
      selectingPassengerID: updateValue.selectingPassengerID || originValue.selectingPassengerID,
      travelers: updateValue.travelers || originValue.travelers,
      deckType: updateValue.deckType || originValue.deckType,
      isSpecifiedStatus: updateValue.isSpecifiedStatus || originValue.isSpecifiedStatus,
      specifiedPassengerID: updateValue.specifiedPassengerID || originValue.specifiedPassengerID,
      prices: updateValue.prices || originValue.prices,
    });
  }

  /**
   * カウチ座席番号の返却処理
   * @param couchList カウチリスト
   * @returns カウチ座席番号　例）71＋ABC=71ABC
   */
  private setCouchSeat(couchList: string[]) {
    let tempSeatNumber = '';
    let tempAlphabet = '';
    couchList.forEach((seatNo) => {
      tempAlphabet += seatNo.replace(/[0-9]/g, '');
      tempSeatNumber = seatNo.replace(/[A-Z]/g, '');
    });

    return tempSeatNumber + tempAlphabet;
  }

  /**
   * この画面で参照するPNR情報が空かどうか判定
   * @param pnr 対象PNR
   * @returns true：空、false：空ではない
   */
  protected _isEmptyPnr(pnr: GetOrderResponseData | undefined): boolean {
    // 各項目チェック
    if (!pnr) return true;

    // バウンド&フライトの1件目が見つからない場合、この画面で参照するPNR情報は空とする
    let bounds = pnr.air?.bounds;
    if (this._isEmptyObj(bounds) || (!!bounds && this._isEmptyObj(bounds[0].flights))) return true;

    // 上記以外の場合、この画面で参照するPNR情報が空ではない
    return false;
  }

  /**
   * オブジェクトの空判定（{}の場合を避けたい。配列ならlength=0も除外）
   * @param obj 判定対象
   * @returns 判定結果 true：空、false：空ではない
   */
  private _isEmptyObj(obj: Object | Object[] | undefined): boolean {
    return !obj || Object.keys(obj).length === 0 || (Array.isArray(obj) && obj.length === 0);
  }

  /**
   * 凡例モーダルを開くクリックイベントハンドラ
   */
  onClickLegend() {
    // 凡例モーダルに対して、現在表示しているキャビンクラスを渡すためStoreに設定
    if (this.displayTargetSegment?.cabin) {
      this.__servicingSeatmapStoreService.updateServicingSeatmap({ cabin: this.displayTargetSegment.cabin });
    }
    const modalPart = this.__modalService.defaultBlockPart(ServicingSeatmapLegendsModalComponent);
    modalPart.type = ModalType.TYPE2;
    modalPart.closeBackEnable = true;
    this.__modalService.showSubModal(modalPart);
  }

  /**
   * 有料席詳細確認モーダル表示
   * @param seatNumber 座席番号
   */
  showPaidSeatDetailConfirmation(seatNumber: string) {
    // 操作前の対象座席の搭乗者情報を取得
    const bfPassengerList = this.selectedSeatInfoList?.find(
      (s) => s.segmentId === this.displayTargetSegmentId
    )?.passengerList;
    const modalPart = this.__modalService.defaultBlockPart(ServicingSeatmapPaidSeatDetailConfirmationComponent);
    modalPart.type = ModalType.TYPE1;
    modalPart.modalWidth = LModalContentsWidthType.MODAL_TAB_W345;
    modalPart.closeBackEnable = true;
    modalPart.payload = this.displayTargetSegment;
    modalPart.closeEvent = () => {
      this.selectedSeatInfoList = this.__servicingSeatmapStoreService.servicingSeatmap.selectedSeatInfoList;

      const isCouchSeat = this.seatInformationMap.get(seatNumber)?.isCouchSeat;

      let isChanges = false;
      this.selectedSeatInfoList
        ?.find((s) => s.segmentId === this.displayTargetSegmentId)
        ?.passengerList?.forEach((p) => {
          const bfSeatNumberList = bfPassengerList?.find((bfp) => bfp.id === p.id)?.seatNumberList;
          const bfSeatNumber = !!bfSeatNumberList && bfSeatNumberList.length > 0 ? bfSeatNumberList[0]?.seatNumber : '';
          const afSeatNumber = !!p.seatNumberList && p.seatNumberList.length > 0 ? p.seatNumberList[0]?.seatNumber : '';
          if (bfSeatNumber !== afSeatNumber) {
            isChanges = true;

            // カウチ席選択時、操作前の対象座席を押下可能（isClickable=true）とするフロー
            // ・操作前の対象座席がSSR登録済みの場合は対象外（SSR無料席以外このフローに到達しない）
            // ・カウチ席選択は複数搭乗者が対象なので、座席変更する各搭乗者の、操作前の対象座席が対象となる

            // 操作前の対象座席がSSR登録済み無料席かどうかフラグ
            let isSsrFreeSeat = false;
            const bfSeatInfo: SeatForServicingSeatmapScreen | undefined = !!bfSeatNumber
              ? this.seatInformationMap?.get(bfSeatNumber)
              : undefined;
            if (!!bfSeatInfo && !bfSeatInfo?.isChargeableAsrSeat && !bfSeatInfo?.isCouchSeat) {
              // 操作前の対象座席が無料席の場合

              // 判定対象の搭乗者のSSR登録済み座席番号を取得（無料席なので固定で0番目参照）
              const pnr: GetOrderResponseData | undefined = this.__servicingCommonStoreService.servicingCommon.getOrder;
              const pnrSeatSelection: OrderSeatItemSeatSelection | undefined =
                pnr?.seats?.[this.displayTargetSegmentId]?.[p.id]?.seatSelection;
              const ssrSeatNumber = pnrSeatSelection?.seatNumbers?.[0];

              // 操作前の対象座席番号と判定対象の搭乗者のSSR登録済み座席番号が一致する場合、操作前の対象座席はSSR登録済み無料席として扱う
              isSsrFreeSeat = !!ssrSeatNumber && bfSeatNumber === ssrSeatNumber;
            }

            // 「当該座席がカウチ席、かつ、操作前の対象座席が存在する、かつ、操作前の対象座席はSSR登録済み無料席ではない」場合、操作前の座席の isClickable に true を設定する
            if (isCouchSeat && !!bfSeatNumber && !isSsrFreeSeat) {
              const bfTravelers = this.seatInformationMap?.get(bfSeatNumber)?.travelers?.map((traveler) => {
                return {
                  id: traveler.id,
                  seatAvailabilityStatus: traveler.seatAvailabilityStatus,
                  isClickable: true,
                  prices: traveler.prices,
                  isExempted: traveler.isExempted,
                } as SeatAvailability;
              });
              this._updateSeatInformationMap(bfSeatNumber, bfTravelers);
            }
          }
        });

      // 操作前後で差がある場合
      if (isChanges) {
        this.isAllSegmentStateChange =
          this.__servicingSeatmapStoreService.servicingSeatmap.isAllSegmentStateChange || false;
        this.isPaidASRCouchNewApplicationAvailable =
          this.__servicingSeatmapStoreService.servicingSeatmap.isPaidASRCouchNewApplicationAvailable || false;
        this.isSeatReservationStatusChangeBySegment =
          this.__servicingSeatmapStoreService.servicingSeatmap.isSeatReservationStatusChangeBySegment || false;

        let seat = this.seatInformationMap?.get(seatNumber);

        if (seat && this.seatInformationMap && seatNumber) {
          let passengerIds: string[] = [];

          // カウチ席の場合、複数搭乗者を指定する。
          if (isCouchSeat) {
            this.selectedSeatInfoList
              ?.find((s) => s.segmentId === this.displayTargetSegmentId)
              ?.passengerList.forEach((passenger) => {
                passengerIds.push(passenger.id);
              });
          } else {
            passengerIds.push(this.selectingPassengerId || '');
          }

          const travelers = seat.travelers?.map((traveler) => {
            return {
              id: traveler.id,
              seatAvailabilityStatus: traveler.seatAvailabilityStatus,
              isClickable: passengerIds.includes(traveler.id) ? true : false,
              prices: traveler.prices,
              isExempted: traveler.isExempted,
            } as SeatAvailability;
          });

          this._updateSeatInformationMap(seatNumber, travelers);
        }

        let nextPassengers: string[] = [];
        let previousPassengerId = this.__servicingSeatmapStoreService.servicingSeatmap.selectingPassengerId;
        let previousPassenger = this.travelersMap.get(previousPassengerId || '');
        this.passengerIdList.forEach((passengerId) => {
          let tempPassenger = this.travelersMap.get(passengerId);
          if (
            !!tempPassenger &&
            !!previousPassenger &&
            this.selectedSeatInfoList
              ?.find((s) => s.segmentId === this.displayTargetSegmentId)
              ?.passengerList.find((p) => p.id === passengerId)?.seatNumberList?.length === 0 &&
            tempPassenger.sequence > previousPassenger.sequence
          ) {
            nextPassengers.push(passengerId);
          }
        });

        // 抽出できた場合、選択状態を切り替える
        if (!!nextPassengers && nextPassengers.length > 0) {
          const nextPassenger = nextPassengers.at(0);
          this.selectingPassengerId = nextPassenger;
        }
      }

      //変更の通知
      this.__changeDetectorRef.markForCheck();
    };

    this.__modalService.showSubModal(modalPart);
  }

  /**
   * シートマップレイアウト詳細モーダルを開くクリックイベントハンドラ
   */
  onClickLayoutDetail() {
    const modalPart = this.__modalService.defaultBlockPart(ServicingSeatmapLayoutDetailModalComponent);
    modalPart.type = ModalType.TYPE4;
    modalPart.modalWidth = LModalContentsWidthType.MODAL_PC_W768;
    modalPart.closeBackEnable = true;
    modalPart.payload = {
      displayTargetSegment: this.displayTargetSegment,
      isInformative: this.isInformative,
      cabinClasses: this.cabinClasses,
      informativeBookingClass: this.informativeBookingClass,
      isAwardBooking: this.pnrInfo?.orderType?.isAwardBooking,
    };
    this.__modalService.showSubModal(modalPart);
  }

  /**
   * シートプロダクト情報モーダルを開くクリックイベントハンドラ
   */
  onClickSeatType() {
    const modalPart = this.__modalService.defaultBlockPart(ServicingSeatmapSeatProductsModalComponent);
    modalPart.type = ModalType.TYPE1;
    modalPart.modalWidth = LModalContentsWidthType.MODAL_TAB_W384;
    modalPart.closeBackEnable = true;
    modalPart.payload = this.displayTargetSegment;
    this.__modalService.showSubModal(modalPart);
  }

  /**
   * セグメントのクリックイベント
   * @param segmentId セグメントID
   */
  onClickSegment(segmentId: string) {
    if (!!segmentId) {
      // 1	セグメント別座席指定状況変更フラグ=trueの場合、以下をパラメータに確認ダイアログ(G02-005)を表示する。
      if (this.isSeatReservationStatusChangeBySegment) {
        // メッセージID=“MSG0535”(今回の操作での座席の更新は破棄される旨)を表示する。
        this.__dialogService
          .openDialog({
            size: DialogSize.L,
            type: DialogType.CHOICE,
            message: `${MasterJsonKeyPrefix.DYNAMIC}MSG0535`,
          })
          .buttonClick$.subscribe((result) => {
            if (result.clickType === DialogClickType.CONFIRM) {
              // セグメントを表示する
              this.showNextSegment(segmentId);
            } else if (result.clickType === DialogClickType.CLOSE) {
              return;
            }
          });
        return;
      }

      // セグメントを表示する
      this.showNextSegment(segmentId);
    }
  }

  /**
   * 選択したセグメントを表示する
   * @param segmentId セグメントID
   */
  showNextSegment(segmentId: string) {
    this.lastDisplayTargetSegmentId = this.displayTargetSegmentId;

    // 2	選択更新破棄処理として、以下の処理を行う。
    // 2.1	変更前選択中座席情報が存在する場合、選択中座席情報リスト.＜表示対象セグメントID＞に変更前選択中座席情報を設定する。
    this.reflectBeforeChange();

    // 2.4	セグメント別座席指定状況変更フラグにfalseを設定する。
    this.isSeatReservationStatusChangeBySegment = false;

    this.__servicingSeatmapStoreService.updateServicingSeatmap({
      displayTargetBoundArrayId: this.displayTargetBoundArrayId,
      displayTargetSegmentArrayId: this.displayTargetSegmentArrayId,
      lastDisplayTargetSegmentId: this.displayTargetSegmentId,
      isRequiredInitDisplay: true,
      isOperationOnProgress: this.isOperationOnProgress,
      isLastSegment: this.isLastSegment,
      isTargetSegmentASREMDAvailable: this.isTargetSegmentASREMDAvailable,
      isTargetSegmentCouchEMDAvailable: this.isTargetSegmentCouchEMDAvailable,
      isPaidASRCouchNewApplicationAvailable: this.isPaidASRCouchNewApplicationAvailable,
      isInformative: false,
      selectedSeatInfoList: this.selectedSeatInfoList,
      childSeatAppliedList: this.childSeatApplicationList,
      originalChildSeatApplicationList: this.originalChildSeatApplicationList,
      isAllSegmentStateChange: this.isAllSegmentStateChange,
      numberOfCouchSeat: this.numberOfCouchSeat,
      segments: this.allSegmentInfo,
      passengerList: this.passengerIdList,
      pnrInfo: this.pnrInfo,
      passengers: Object.fromEntries(this.travelersMap),
      isSeatReservationStatusChangeBySegment: this.isSeatReservationStatusChangeBySegment,
      numberOfChildSeats: this.numberOfChildSeats,
      seatmap: Object.fromEntries(this.seatInformationMap),
      seatNumber: this.selectingSeatNumber,
      selectingPassengerId: this.selectingPassengerId,
      functionId: ServicingFunctionIdType.SEATMAP,
      pageId: ServicingPageIdType.SEATMAP,
    });

    this.__servicingCommonStoreService.updateServicingCommon({
      backupLanguage: 'jp',
      displayTargetSegmentId: segmentId,
    });

    // 画面をリロードする
    this.__router.navigate([SERVICING_ROUTES.seatMap]);
  }

  /**
   * 次のフライトへ遷移
   */
  showNextFlight() {
    this.lastDisplayTargetSegmentId = this.displayTargetSegmentId;

    // 次セグメント指定処理を行う

    // 次セグメント情報の設定要求フラグ
    let isRequestInitNextSegInfo: boolean = false;

    // 次セグメント情報発見フラグ
    let existsNextSegInfo: boolean = false;

    // バウンド毎ループ処理開始前、表示対象バウンド配列IDを0に設定
    this.displayTargetBoundArrayId = 0;

    // バウンド毎ループ処理を実行する
    for (const bound of this.pnrInfo?.air?.bounds || []) {
      // バウンド毎ループ処理開始時、表示対象セグメント配列IDを0に設定
      this.displayTargetSegmentArrayId = 0;

      // セグメント毎ループ処理を実行する
      for (const segment of bound.flights || []) {
        if (isRequestInitNextSegInfo) {
          // 次セグメント情報の設定要求フラグがtrueの場合、現時点のセグメント情報を次セグメントとして扱う
          // 表示対象セグメントIDに、次セグメントのIDを設定する
          // 次セグメントのIDが取得できない場合、セグメントIDは空文字として扱う（遷移後の初期表示で表示対象セグメントを再決定する）
          this.displayTargetSegmentId = segment.id || '';

          // 次セグメントを見つけたら、次セグメント情報発見フラグをtrueに設定して、セグメント毎ループ処理を抜ける
          existsNextSegInfo = true;
          break;
        } else if (segment.id === this.displayTargetSegmentId) {
          // 現在表示中のセグメントIDと合致する場合、次セセグメント情報の設定要求フラグにtrueを設定する
          // 次のループで参照できるセグメント情報が、次セグメントの情報となる
          isRequestInitNextSegInfo = true;
        }

        // 次のセグメント毎ループ処理へ進む場合、表示対象セグメント配列IDを加算
        ++this.displayTargetSegmentArrayId;
      }

      if (existsNextSegInfo) {
        // 次セグメント情報発見フラグがtrueの場合、バウンド毎ループ処理を抜ける
        break;
      } else {
        // 次のバウンド毎ループ処理へ進む場合、表示対象バウンド配列IDを加算
        ++this.displayTargetBoundArrayId;
      }
    }

    // セグメント別座席指定状況変更フラグにfalseを設定する。
    this.isSeatReservationStatusChangeBySegment = false;

    // ストア情報を更新する。
    this.__servicingSeatmapStoreService.updateServicingSeatmap({
      displayTargetBoundArrayId: this.displayTargetBoundArrayId,
      displayTargetSegmentArrayId: this.displayTargetSegmentArrayId,
      lastDisplayTargetSegmentId: this.lastDisplayTargetSegmentId,
      isRequiredInitDisplay: true,
      isOperationOnProgress: this.isOperationOnProgress,
      isLastSegment: this.isLastSegment,
      isTargetSegmentASREMDAvailable: this.isTargetSegmentASREMDAvailable,
      isTargetSegmentCouchEMDAvailable: this.isTargetSegmentCouchEMDAvailable,
      isPaidASRCouchNewApplicationAvailable: this.isPaidASRCouchNewApplicationAvailable,
      isInformative: false,
      selectedSeatInfoList: this.selectedSeatInfoList,
      childSeatAppliedList: this.childSeatApplicationList,
      originalChildSeatApplicationList: this.originalChildSeatApplicationList,
      isAllSegmentStateChange: this.isAllSegmentStateChange,
      numberOfCouchSeat: this.numberOfCouchSeat,
      segments: this.allSegmentInfo,
      passengerList: this.passengerIdList,
      pnrInfo: this.pnrInfo,
      passengers: Object.fromEntries(this.travelersMap),
      isSeatReservationStatusChangeBySegment: this.isSeatReservationStatusChangeBySegment,
      numberOfChildSeats: this.numberOfChildSeats,
      seatmap: Object.fromEntries(this.seatInformationMap),
      seatNumber: this.selectingSeatNumber,
      selectingPassengerId: this.selectingPassengerId,
      functionId: ServicingFunctionIdType.SEATMAP,
      pageId: ServicingPageIdType.SEATMAP,
    });

    this.__servicingCommonStoreService.updateServicingCommon({
      backupLanguage: 'jp',
      displayTargetSegmentId: this.displayTargetSegmentId,
    });

    // 画面をリロードする
    this.__router.navigate([SERVICING_ROUTES.seatMap]);
  }

  /**
   * 指定状況詳細(PNR)モーダル表示
   */
  showPNRModal() {
    const modalPart = this.__modalService.defaultBlockPart(ServicingSeatmapConfirmSeatReservationComponent);
    modalPart.type = ModalType.TYPE4;
    modalPart.modalWidth = LModalContentsWidthType.MODAL_PC_W1000;
    modalPart.closeBackEnable = true;
    modalPart.payload = this.displayTargetSegment;
    modalPart.closeEvent = () => {
      this.__servicingSeatmapStoreService.updateServicingSeatmap({
        isRequiredInitDisplay: true,
        isConfirmClick: false,
      });
    };

    this.__modalService.showSubModal(modalPart);
  }

  /**
   * セグメントスキップ処理
   * @param errorMsgId エラーメッセージID
   * @param apiErrorCode APIからのレスポンスエラーID
   */
  protected segmentSkip(errorMsgId?: string, apiErrorCode?: string) {
    let skipSegmentInfoList = this.__servicingSeatmapStoreService.servicingSeatmap.skipSegmentInfoList;

    // スキップセグメント情報リストが取得できない場合はセグメントなしのため予約詳細画面(S01-P030)へ遷移する。
    if (!skipSegmentInfoList || skipSegmentInfoList?.length == 0) {
      this.___pageInitService.endInit(null);
      // 予約詳細表示タブに「service」を設定
      this.__servicingCommonStoreService.updateServicingCommon({
        initDisplayService: 'seatRequest',
        tabShow: 'service',
      });
      this.__router.navigate([SERVICING_ROUTES.myBooking]);
      return;
    }

    // 表示対象セグメントIDが設定されていない場合、先頭のセグメントのIDを設定
    if (!this.displayTargetSegmentId) {
      this.displayTargetSegmentId = skipSegmentInfoList![0].segmentId;
    }

    // スキップ対象のスキップセグメント情報を更新(取得できない場合は予約詳細画面(S01-P030)へ遷移する。)
    let newSkipSegmentInfoList = skipSegmentInfoList?.map((value) => {
      if (value.segmentId === this.displayTargetSegmentId) {
        return {
          ...value,
          isSkip: true,
        };
      } else {
        return value;
      }
    });

    // スキップセグメントIDマップを更新
    this.__servicingSeatmapStoreService.updateServicingSeatmap({
      skipSegmentInfoList: newSkipSegmentInfoList,
    });

    // 表示可能な次のセグメントのIDを取得
    let nextSegmentId: string = '';
    let skipSegmentIndex = newSkipSegmentInfoList!.findIndex((s) => s.segmentId === this.displayTargetSegmentId);
    for (let i = skipSegmentIndex; i < newSkipSegmentInfoList!.length; i++) {
      if (!newSkipSegmentInfoList![i].isSkip) {
        nextSegmentId = newSkipSegmentInfoList![i].segmentId;
        break;
      }
    }

    // 初期化終了処理の呼び出し
    this.___pageInitService.endInit(null);

    // 条件に応じたスキップ処理フローの実施
    if (!!nextSegmentId) {
      // 次に表示するセグメントが存在する場合

      // スキップ時の別セグ遷移も、任意のセグに移動する処理として扱う
      // 選択したセグを表示する（showNextSegment）処理に準拠してパラメータ設定
      this.lastDisplayTargetSegmentId = this.displayTargetSegmentId;
      this.isSeatReservationStatusChangeBySegment = false;

      this.__servicingSeatmapStoreService.updateServicingSeatmap({
        displayTargetBoundArrayId: this.displayTargetBoundArrayId,
        displayTargetSegmentArrayId: this.displayTargetSegmentArrayId,
        lastDisplayTargetSegmentId: this.displayTargetSegmentId,
        isRequiredInitDisplay: true,
        isOperationOnProgress: this.isOperationOnProgress,
        isLastSegment: this.isLastSegment,
        isTargetSegmentASREMDAvailable: this.isTargetSegmentASREMDAvailable,
        isTargetSegmentCouchEMDAvailable: this.isTargetSegmentCouchEMDAvailable,
        isPaidASRCouchNewApplicationAvailable: this.isPaidASRCouchNewApplicationAvailable,
        isInformative: false,
        selectedSeatInfoList: this.selectedSeatInfoList,
        childSeatAppliedList: this.childSeatApplicationList,
        originalChildSeatApplicationList: this.originalChildSeatApplicationList,
        isAllSegmentStateChange: this.isAllSegmentStateChange,
        numberOfCouchSeat: this.numberOfCouchSeat,
        segments: this.allSegmentInfo,
        passengerList: this.passengerIdList,
        pnrInfo: this.pnrInfo,
        passengers: Object.fromEntries(this.travelersMap),
        isSeatReservationStatusChangeBySegment: this.isSeatReservationStatusChangeBySegment,
        numberOfChildSeats: this.numberOfChildSeats,
        seatmap: Object.fromEntries(this.seatInformationMap),
        seatNumber: this.selectingSeatNumber,
        selectingPassengerId: this.selectingPassengerId,
        functionId: ServicingFunctionIdType.SEATMAP,
        pageId: ServicingPageIdType.SEATMAP,
      });

      // サービシング共通へ値を設定
      // ワーニングメッセージIDにセグメントスキップ処理呼び出し時に渡されたメッセージID、または”W0576”を設定する。
      this.__servicingCommonStoreService.updateServicingCommon({
        displayTargetSegmentId: nextSegmentId,
        preWarningMessageList: [
          {
            contentHtml: errorMsgId || 'W0576',
            isCloseEnable: true,
            errorMessageId: errorMsgId || 'W0576',
            apiErrorCode: apiErrorCode,
          },
        ],
        backupLanguage: 'jp',
      });

      this.__router.navigate([SERVICING_ROUTES.seatMap]);
    } else {
      // 次に表示するセグメントが存在しない場合

      // 遷移元画面識別子　※シートマップ画面（座席属性指定画面含む）か、予約詳細画面のような他画面か判別可能。遷移元として利用する。
      const previousPageIdentifier = this.__servicingCommonStoreService.servicingCommon.previousPageIdentifier;

      // シートマップ遷移元画面ID　※シートマップ画面（座席属性画面含む）へ流入した際の遷移元画面識別子が設定されている。戻り先として利用する。
      const seatmapPreviousPageIdentifier =
        this.__servicingSeatmapStoreService.servicingSeatmap.seatmapPreviousPageIdentifier;

      if (!previousPageIdentifier || !seatmapPreviousPageIdentifier) {
        // 遷移元画面識別子が未設定、または、シートマップ遷移元画面IDが未設定の場合（イレギュラーなフロー）
        // 継続不可能エラータイプに”system”(システムエラー)にて継続不可能なエラー情報を指定し、共通エラー画面に遷移する。
        this.____commonService.errorsHandlerService.setNotRetryableError({ errorType: ErrorType.SYSTEM });
        return;
      }

      // 遷移元が予約詳細画面かどうか
      const isPrevPageMybooking: boolean = PREVIOUS_PAGE_IDENTIFIER.MYBOOKING === previousPageIdentifier;

      if (!isPrevPageMybooking && !!this.__servicingSeatmapStoreService.servicingSeatmap.isAllSegmentStateChange) {
        // 遷移元が予約詳細画面以外、かつ、全セグメントのいずれかで変更がある場合
        // このフローではワーニングメッセージ設定不要

        // 最後に表示していたセグメントIDを設定
        nextSegmentId =
          this.__servicingSeatmapStoreService.servicingSeatmap.lastDisplayTargetSegmentId ||
          this.lastDisplayTargetSegmentId;

        // 指定状況詳細(PNR)モーダル表示
        this.showPNRModal();

        // サービシング共通へ値を設定
        this.__servicingCommonStoreService.updateServicingCommon({
          displayTargetSegmentId: nextSegmentId,
        });

        // シートマップ画面を再表示する
        this.__router.navigate([SERVICING_ROUTES.seatMap]);
      } else {
        // 遷移元が予約詳細画面の場合、または、全セグメント変更していない場合

        // シートマップ遷移前の画面へ遷移
        // ワーニングメッセージIDにセグメントスキップ処理呼び出し時に渡されたメッセージID、または”W0576”を設定する。
        this.__servicingCommonStoreService.updateServicingCommon({
          initDisplayService: 'seatRequest',
          tabShow: 'service',
          displayTargetSegmentId: nextSegmentId,
          preWarningMessageList: [
            {
              contentHtml: errorMsgId || 'W0576',
              isCloseEnable: true,
              errorMessageId: errorMsgId || 'W0576',
              apiErrorCode: apiErrorCode,
            },
          ],
        });
        this.__router.navigate([seatmapPreviousPageIdentifier]);
        return;
      }
    }
  }

  /**
   * 保存して終了ボタン押下
   */
  onClickSubmit() {
    // 以下の有料ASR席の判定条件全て、またはカウチ席の判定条件全てを満たす搭乗者が存在する場合、
    // エラーメッセージID=”E0578”(有料ASR席の取消およびカウチ席の取消と座席の指定は同時に行えない旨)にて継続可能なエラー情報を指定し、後続処理は実施しない。
    const isCancellingPaidSeatAndSelectingAnotherSeat = this._isCancellingPaidSeatAndSelectingAnotherSeat();

    if (isCancellingPaidSeatAndSelectingAnotherSeat) {
      this.____commonService.errorsHandlerService.setRetryableError(PageType.PAGE, { errorMsgId: 'E0578' });
      return;
    }

    // カウチ席の安全規定のチェック判定処理
    if (this.isAcceptSafetyRegulationLimitationsCheck()) {
      return;
    }

    // 表示中セグメント変更発生有無判定処理
    if (this.isSeatProcuranceFailure(false)) {
      // 画面.指定状況詳細(PNR)モーダルを表示する。
      this.showPNRModal();
    }
  }

  /**
   * 有料ASR席またはカウチ席の取消と座席の指定を同時に行っているか判定
   */
  private _isCancellingPaidSeatAndSelectingAnotherSeat(): boolean {
    // 有料ASR席またはカウチ席の取消を行っている搭乗者がいるか
    let isCancellingPaidSeat = false;

    // 新たな座席の指定を行っている搭乗者がいるか
    let isSelectingAnotherSeat = false;

    // 座席属性の変更を行っている搭乗者がいるか
    let isChangeSeatAttribute = false;

    // 全セグの全搭乗者を確認
    this.selectedSeatInfoList?.forEach((segment) => {
      segment.passengerList?.forEach((passenger) => {
        // 選択座席
        let selectedSeatNumberList = passenger.seatNumberList;
        let selectedCouchSeatNumberList = passenger.couchSeatNumberList;

        // 登録済み座席
        let pnrSeatNumbers = this.pnrInfo?.seats?.[segment.segmentId]?.[passenger.id]?.seatSelection?.seatNumbers;

        // 登録済みカウチ座席番号
        let pnrCouchSeatNumber =
          this.pnrInfo?.seats?.[segment.segmentId]?.[passenger.id].seatSelection?.couchSeatNumber;

        // 新たな座席の指定を行っているかの判定(カウチ)
        if (
          !!selectedCouchSeatNumberList &&
          selectedCouchSeatNumberList.length > 0 &&
          !!selectedCouchSeatNumberList[0].seatNumber
        ) {
          //もともとカウチ席を指定していて変更無しの場合は除外
          if (!!pnrCouchSeatNumber) {
            if (!!selectedCouchSeatNumberList && pnrCouchSeatNumber !== selectedCouchSeatNumberList[0].seatNumber) {
              isSelectingAnotherSeat = true;
            }
          } else {
            isSelectingAnotherSeat = true;
          }
          // 新たな座席の指定を行っているかの判定(カウチ以外)
        } else if (
          !!selectedSeatNumberList &&
          selectedSeatNumberList.length > 0 &&
          !!selectedSeatNumberList[0].seatNumber
        ) {
          //もともと座席を指定していて変更無しの場合は除外
          if (!!pnrSeatNumbers && pnrSeatNumbers?.length > 0) {
            if (pnrSeatNumbers[0] !== selectedSeatNumberList[0].seatNumber) {
              isSelectingAnotherSeat = true;
            }
          } else {
            isSelectingAnotherSeat = true;
          }
        }

        let defaultSeatmapInfoBySegmentList =
          this.__servicingSeatmapStoreService.servicingSeatmap.defaultSeatmapInfoBySegmentList || undefined;

        // 登録済み座席が存在する場合
        if (!!defaultSeatmapInfoBySegmentList && !!pnrSeatNumbers && pnrSeatNumbers?.length > 0) {
          const seatInformations = defaultSeatmapInfoBySegmentList[segment.segmentId]?.seatInformations;
          const seatInformation = !!seatInformations ? seatInformations[pnrSeatNumbers[0]] : undefined;

          // 登録済み座席が有料ASR席の場合
          if (seatInformation?.isChargeableAsrSeat) {
            // 有料ASR席の取消を行っているかの判定
            if (
              !!selectedSeatNumberList &&
              (selectedSeatNumberList.length <= 0 ||
                (selectedSeatNumberList.length > 0 &&
                  !!selectedSeatNumberList[0].seatNumber &&
                  pnrSeatNumbers[0] !== selectedSeatNumberList[0].seatNumber))
            ) {
              isCancellingPaidSeat = true;
            }

            // 登録済み座席がカウチ席の場合
          } else if (seatInformation?.isCouchSeat) {
            // カウチ席の取消を行っているかの判定
            if (
              !!selectedCouchSeatNumberList &&
              !!pnrCouchSeatNumber &&
              (selectedCouchSeatNumberList.length <= 0 ||
                (selectedCouchSeatNumberList.length > 0 &&
                  !!selectedCouchSeatNumberList[0].seatNumber &&
                  pnrCouchSeatNumber !== selectedCouchSeatNumberList[0].seatNumber))
            ) {
              isCancellingPaidSeat = true;
            }
          }
        }

        // 座席属性が変更された場合
        if (this.__seatmapService.isChangedSeatAttribute(segment)) {
          isChangeSeatAttribute = true;
        }
      });
    });

    return !!isCancellingPaidSeat && (!!isSelectingAnotherSeat || !!isChangeSeatAttribute);
  }

  /**
   * 次のフライトへボタンクリックイベント
   */
  onClickNextFlight() {
    // カウチ席の安全規定のチェック判定処理
    if (this.isAcceptSafetyRegulationLimitationsCheck()) {
      return;
    }

    if (this.isSeatProcuranceFailure(true)) {
      // 次のフライトへ
      this.showNextFlight();
    }
  }

  /**
   * 座席指定内容に関する案内表示処理
   * シートマップ上は空席に見えても座席確保不可となる可能性があるかどうか
   * @param isNextFlight 次のフライトへボタン押下かどうか
   */
  isSeatProcuranceFailure(isNextFlight: boolean) {
    // [以下、座席指定内容に関する案内表示処理]
    // 2.1.1.1	選択中座席情報リスト.＜表示対象セグメントID＞.搭乗者リスト.座席番号が存在する
    // 2.1.1.2	シートマップ情報.data.seatmapFlightProperty.isSeatProcuranceFailure=true
    if (
      this.selectedSeatInfoList
        ?.find((s) => s.segmentId === this.displayTargetSegmentId)
        ?.passengerList.some((p) => this._isSelectedSeatNumber(p.seatNumberList)) &&
      this.seatmapResponse?.data.seatmapFlightProperty.isSeatProcuranceFailure
    ) {
      // 2.1.1	以下の条件全てを満たす場合、動的文言ID=”MSG0624”
      // (シートマップ上は空席に見えても座席確保不可となる可能性がある旨)にて継続可能なエラー情報を指定する。
      this.__dialogService
        .openDialog({
          size: DialogSize.L,
          type: DialogType.CHOICE,
          message: `${MasterJsonKeyPrefix.DYNAMIC}MSG0624`,
        })
        .buttonClick$.subscribe((result) => {
          if (result.clickType === DialogClickType.CONFIRM) {
            if (!this.hasUnregisteredSeat(isNextFlight)) {
              if (isNextFlight) {
                // 次のフライトへ
                this.showNextFlight();
              } else {
                // PNRモーダル表示
                this.showPNRModal();
              }
            }
          } else if (result.clickType === DialogClickType.CLOSE) {
            return;
          }
        });

      return false;
    }

    return !this.hasUnregisteredSeat(isNextFlight);
  }

  /**
   * 座席が選択済みかどうか判定
   * @param seatNumberList 座席番号リスト
   */
  private _isSelectedSeatNumber(seatNumberList: SeatNumbers[] | undefined) {
    return !!seatNumberList && seatNumberList.length >= 1 && !!seatNumberList[0];
  }

  /**
   * 座席指定内容に関する案内表示処理
   * 座席未指定の搭乗者が存在するかどうか
   * @param isNextFlight 次のフライトへボタン押下かどうか
   * @returns
   */
  hasUnregisteredSeat(isNextFlight: boolean) {
    let numberOfSeats = this.seatmapResponse?.data.seatmaps.numberOfAvailableSeats || 0;
    let seatInfoListCount = 0;
    this.selectedSeatInfoList
      ?.find((s) => s.segmentId === this.displayTargetSegmentId)
      ?.passengerList.forEach((p) => {
        if (!!p.seatNumberList && p.seatNumberList.length > 0) {
          ++seatInfoListCount;
        }
      });

    let travelerSeatCount = 0;
    for (let passengerId of this.passengerIdList) {
      let tempSeatNumber = this.selectedSeatInfoList
        ?.find((s) => s.segmentId === this.displayTargetSegmentId)
        ?.passengerList.find((p) => p.id === passengerId)?.seatNumberList;
      let tempCouchSeatNumber = this.selectedSeatInfoList
        ?.find((s) => s.segmentId === this.displayTargetSegmentId)
        ?.passengerList.find((p) => p.id === passengerId)?.couchSeatNumberList;
      let tempPassenger = this.pnrInfo?.seats?.[this.displayTargetSegmentId]?.[passengerId];
      if (
        !!tempPassenger &&
        !!tempPassenger.seatSelection.seatNumbers &&
        tempPassenger.seatSelection.seatNumbers.length > 0
      ) {
        if (!!tempSeatNumber && tempSeatNumber?.length > 0) {
          // 選択中座席情報リスト.[表示対象セグメントID].[当該搭乗者ID].couchSeatNumberList!=''かつ
          // 選択中座席情報リスト.[表示対象セグメントID].[当該搭乗者ID].couchSeatNumberList[0].seatNumber!=''かつ
          // 選択中座席情報リスト.[表示対象セグメントID].[当該搭乗者ID].couchSeatNumberList[0].seatNumber=
          // PNR情報.seats.[表示対象セグメントID].[当該搭乗者ID].seatSelection.couchSeatNumberの場合、次の繰り返し処理を行う。
          if (
            tempCouchSeatNumber &&
            tempCouchSeatNumber.length > 0 &&
            tempCouchSeatNumber[0]?.seatNumber &&
            tempCouchSeatNumber[0]?.seatNumber === tempPassenger.seatSelection.couchSeatNumber
          ) {
            continue;
          }

          if (tempPassenger.seatSelection.seatNumbers[0] !== tempSeatNumber[0].seatNumber) {
            ++travelerSeatCount;
          }
        } else {
          ++travelerSeatCount;
        }
      }
    }

    let travelerTotal = this.pnrInfo?.travelersSummary?.travelerNumbers?.total || 0;
    let travelerInf = this.pnrInfo?.travelersSummary?.travelerNumbers?.INF || 0;

    // 2.1.2	以下の条件全てを満たす場合、動的文言ID=”MSG0482”(座席未指定の搭乗者が存在する旨)にて継続可能なエラー情報を指定する。
    // 2.1.2.1 シートマップ情報.data.seatmaps.numberOfAvailableSeats>表示対象セグメントIDに紐づく選択中座席情報リスト.＜当該表示対象セグメントID＞の要素数+
    // 表示対象セグメントIDに紐づくPNR情報.data.seats.＜表示対象セグメントID＞の要素数かつ
    // 2.1.2.2 表示対象セグメントIDに紐づくPNR情報.data.seats.＜表示対象セグメントID＞の要素数+
    // 表示対象セグメントIDに紐づく選択中座席情報リスト.＜表示対象セグメントID＞の要素数<PNR情報.data.travelersSummary.travelerNumbers(以下、搭乗者人数).total-搭乗者人数.INF
    if (
      numberOfSeats > seatInfoListCount + travelerSeatCount &&
      travelerSeatCount + seatInfoListCount < travelerTotal - travelerInf
    ) {
      this.__dialogService
        .openDialog({
          size: DialogSize.L,
          type: DialogType.CHOICE,
          message: `${MasterJsonKeyPrefix.DYNAMIC}MSG0482`,
        })
        .buttonClick$.subscribe((result) => {
          if (result.clickType === DialogClickType.CONFIRM) {
            if (isNextFlight) {
              // 次のフライトへ
              this.showNextFlight();
            } else {
              // PNRモーダル表示
              this.showPNRModal();
            }
          } else if (result.clickType === DialogClickType.CLOSE) {
            return;
          }
        });

      return true;
    }
    // [ここまで、座席指定内容に関する案内表示処理]

    return false;
  }

  /**
   * 変更前の座席情報を保存
   */
  protected saveBeforeChange() {
    if (!!this.selectedSeatInfoList) {
      // 選択中座席情報リストが存在する場合、次の繰り返し処理を行う。
      for (let seat of this.selectedSeatInfoList) {
        // 選択中座席情報.セグメントIDが存在するかつ、表示対象セグメントIDが存在するかつ、選択中座席情報.セグメントID=表示対象セグメントIDの場合
        if (!!seat.segmentId && !!this.displayTargetSegmentId && seat.segmentId === this.displayTargetSegmentId) {
          // 変更前選択中座席情報に選択中座席情報を設定する。
          this.selectedSeatBeforeChange = seat;
          break;
        }
      }
    }
  }

  /**
   * 変更前の座席情報を反映
   */
  protected reflectBeforeChange() {
    if (!!this.selectedSeatBeforeChange) {
      if (!this.selectedSeatInfoList) {
        this.selectedSeatInfoList = [];
        this.selectedSeatInfoList.push(this.selectedSeatBeforeChange);
      } else {
        let newSelectedSeatInfoList = this.selectedSeatInfoList.map((seatInfo) => {
          if (seatInfo.segmentId === this.selectedSeatBeforeChange?.segmentId) {
            return this.selectedSeatBeforeChange;
          } else {
            return seatInfo;
          }
        });
        this.selectedSeatInfoList = newSelectedSeatInfoList;
      }
    }
  }

  /**
   * セグメント別座席情報を設定
   */
  protected _getDefaultSeatmapInfoBySegment() {
    // 参照の場合は処理しない
    if (!this.seatInformationMap) {
      return {};
    }

    // 表示対象セグをget-seatmapsで取得した内容（seatInformationMap）を設定
    let newDefaultSeatmapInfoBySegmentList = new Map<string, SeatForServicingSeatmapScreenBySegment>();
    newDefaultSeatmapInfoBySegmentList.set(this.displayTargetSegmentId, {
      segmentId: this.displayTargetSegmentId,
      seatInformations: Object.fromEntries(this.seatInformationMap),
      seatmaps: this.seatmapResponse?.data?.seatmaps,
    });

    // ストアに保持した内容を設定
    let defaultSeatmapInfoBySegmentList =
      this.__servicingSeatmapStoreService.servicingSeatmap.defaultSeatmapInfoBySegmentList || undefined;

    // 他セグの情報が存在する場合は詰めなおす（今回の表示セグ内容＋従来の他セグ内容とするため）
    // また、「今回の表示セグ内容が取得できない、かつ、表示セグ内容が保持できている（以前に取得できたタイミングが存在）」場合は、その内容を適用する。
    if (!!defaultSeatmapInfoBySegmentList) {
      // ストアに保持した内容
      let seatmapInfoBySegmentList = new Map<string, SeatForServicingSeatmapScreenBySegment>(
        Object.entries(defaultSeatmapInfoBySegmentList)
      );
      seatmapInfoBySegmentList.forEach((seatInformations, segmentId) => {
        if (!!segmentId && segmentId !== this.displayTargetSegmentId) {
          // 他セグの場合は、無条件に詰めなおす
          newDefaultSeatmapInfoBySegmentList.set(segmentId, {
            segmentId: segmentId,
            seatInformations: seatInformations.seatInformations,
            seatmaps: seatInformations.seatmaps,
          });
        } else if (
          !!segmentId &&
          segmentId === this.displayTargetSegmentId &&
          (!this.seatInformationMap || this.seatInformationMap.size === 0) &&
          !!seatInformations.seatInformations
        ) {
          // 自セグの場合は、「今回seatInformationMapが取得できてない、かつ、座席ストアに保持した内容は存在する」場合に詰めなおす
          // ※初回など「今回取得できない、かつ、ストア保持した内容も存在しない」場合は、初期値として今回内容まま設定
          newDefaultSeatmapInfoBySegmentList.set(segmentId, {
            segmentId: segmentId,
            seatInformations: seatInformations.seatInformations,
            seatmaps: seatInformations.seatmaps,
          });
        }
      });
    }

    return Object.fromEntries(newDefaultSeatmapInfoBySegmentList);
  }

  /**
   * 選択可否情報の更新
   * @param seatNumber 座席番号
   * @param travelers 座席利用情報
   */
  private _updateSeatInformationMap(seatNumber: string, travelers: SeatAvailability[] | undefined) {
    let seat = this.seatInformationMap?.get(seatNumber);
    this.seatInformationMap.set(seatNumber, {
      blockInformation: seat?.blockInformation,
      columnArrayID: seat?.columnArrayID,
      columnNumber: seat?.columnNumber,
      couchNumber: seat?.couchNumber,
      deckType: seat?.deckType,
      isChargeableAsrSeat: seat?.isChargeableAsrSeat,
      isChildSeatAttachable: seat?.isChildSeatAttachable!,
      isCouchSeat: seat?.isCouchSeat,
      isRearDirectionSeat: seat?.isRearDirectionSeat,
      isSpecifiedStatus: seat?.isSpecifiedStatus,
      registedPassengerID: seat?.registedPassengerID,
      rowArrayID: seat?.rowArrayID,
      rowNumber: seat?.rowNumber,
      seatCharacteristicsCodes: seat?.seatCharacteristicsCodes,
      selectingPassengerID: seat?.selectingPassengerID,
      specifiedPassengerID: seat?.specifiedPassengerID,
      travelers: travelers,
      prices: seat?.prices,
    });

    this.__servicingSeatmapStoreService.updateServicingSeatmap({
      seatmap: Object.fromEntries(this.seatInformationMap),
    });
  }

  /**
   * カウチ席の安全規定の制限チェック
   *
   * @returns true:制限あり false:制限なし
   */
  private isAcceptSafetyRegulationLimitationsCheck(): boolean {
    // 搭乗者IDとカウチ席番号を保持するMapを定義する。
    let couchSeatSelectingPassengerIdMap = new Map<string, string>();
    // 選択済みカウチ席番号Setを定義する。
    let couchSeatNumberSet = new Set<string>();

    // 全PAXでカウチ席番号が存在していたら、Mapに搭乗者IDとカウチ席番号、Setにカウチ席番号を設定する。
    if (!!this.selectedSeatInfoList) {
      for (let selectedSeatInfo of this.selectedSeatInfoList) {
        if (selectedSeatInfo.segmentId === this.displayTargetSegmentId) {
          for (let passenger of selectedSeatInfo.passengerList) {
            if (
              !!passenger.couchSeatNumberList &&
              passenger.couchSeatNumberList.length > 0 &&
              !!passenger.couchSeatNumberList[0].seatNumber
            ) {
              couchSeatSelectingPassengerIdMap.set(passenger.id, passenger.couchSeatNumberList[0].seatNumber);
              couchSeatNumberSet.add(passenger.couchSeatNumberList[0].seatNumber);
            }
          }

          for (let couchSeatNumber of couchSeatNumberSet) {
            // カウチ席を選択している搭乗者IDを保持する配列を定義する。
            let passengerIdSelectingCouchSeat: string[] = [];

            // カウチ席ごとに搭乗者IDを整形する。
            couchSeatSelectingPassengerIdMap.forEach((value, key) => {
              if (couchSeatNumber === value) {
                passengerIdSelectingCouchSeat.push(key);
              }
            });

            // カウチ席申込人数カウントに0を設定する。
            let couchSeatAppliedPassengerCount = 0;
            // 同伴者存在有無としてfalseを保持する。
            let isCompanionExist = false;
            // 搭乗者マップ.＜当該搭乗者ID＞.搭乗者種別="ADT"、または"B15"（大人）の人数として0を設定する。
            let adultCount = 0;
            // 幼児人数として0を設定する。
            let infantCount = 0;
            // 席なし幼児人数として0を設定する。
            let infantWithoutSeatCount = 0;

            // ＜以下、カウチ席を選択している搭乗者IDリストの要素数分、繰り返し＞
            for (let checkingPassengerId of passengerIdSelectingCouchSeat) {
              let checkingPassenger = this.travelersMap?.get(checkingPassengerId);

              // 搭乗者マップ.＜当該搭乗者ID＞.搭乗者種別="INF"以外の場合、カウチ席申込人数カウントをインクリメントする。
              // ※搭乗者種別="INF" の場合、accompanyingInfant に設定される認識なので基本的には通らない認識
              if (checkingPassenger?.passengerTypeCode !== 'INF') {
                couchSeatAppliedPassengerCount += 1;
              }

              // 搭乗者マップ.＜当該搭乗者ID＞.搭乗者種別="ADT"、または"B15"の場合、同伴者存在有無にtrueを設定し、大人またはヤングアダルトの搭乗者人数をインクリメントする。
              if (checkingPassenger?.passengerTypeCode === 'ADT' || checkingPassenger?.passengerTypeCode === 'B15') {
                isCompanionExist = true;
                adultCount += 1;
              }

              // 以下のいずれかの条件に該当する場合、席なし幼児人数をインクリメントする。
              // ・搭乗者マップ.＜当該搭乗者ID＞.同伴幼児情報が存在する場合
              // ・搭乗者マップ.＜当該搭乗者ID＞.幼児情報不明=trueの場合
              // ・搭乗者マップ.＜当該搭乗者ID＞.幼児同伴の大人=trueの場合
              if (
                !!checkingPassenger?.accompanyingInfant ||
                checkingPassenger?.hasNamelessInfant ||
                checkingPassenger?.hasInfiniNamelessInfant
              ) {
                infantWithoutSeatCount += 1;
              }

              // 以下のいずれかの条件に該当する場合、幼児人数をインクリメントする。
              // ・搭乗者マップ.＜当該搭乗者ID＞.同伴幼児情報が存在する場合
              // ・搭乗者マップ.＜当該搭乗者ID＞.搭乗者種別="INS"の場合
              // ・搭乗者マップ.＜当該搭乗者ID＞.幼児情報不明=trueの場合
              // ・搭乗者マップ.＜当該搭乗者ID＞.幼児同伴の大人=trueの場合
              if (
                !!checkingPassenger?.accompanyingInfant ||
                checkingPassenger?.passengerTypeCode === 'INS' ||
                checkingPassenger?.hasNamelessInfant ||
                checkingPassenger?.hasInfiniNamelessInfant
              ) {
                infantCount += 1;
              }
            } // ＜ここまで、カウチ席を選択している搭乗者IDリストの要素数分、繰り返し＞

            // 以下のいずれかに該当する場合、安全規定制限フラグに true を設定し、”E0583”（安全規定の制限がある旨）を表示する。
            // ・幼児が存在する、かつ搭乗者種別が大人またはヤングアダルトの搭乗者が存在しない場合
            // ・大人の旅客1人に対して3人以上の幼児が存在する（カウチ席内人数(大人・ヤングアダルト)×2 < 幼児人数）場合
            if ((infantCount > 0 && !isCompanionExist) || adultCount * 2 < infantCount) {
              this.____commonService.errorsHandlerService.setRetryableError(PageType.PAGE, { errorMsgId: 'E0583' });
              // 制限ありとしてtrueを返す。
              return true;
            }
          }
        }
      }
    }

    // 制限なしとしてfalseを返す。
    return false;
  }

  /**
   * 指定セグのselectedSeatInfoListに含まれる座席属性の値を更新する。この処理ではStore更新は実施しない。
   * @param segId 更新対象のセグメントID
   * @param characteristicRequestSsrCode 更新する座席属性の値
   */
  updateSelectedSeatInfoListSeatAttribute(segId: string, characteristicRequestSsrCode: string) {
    let newSelectedSeatInfoList = this.selectedSeatInfoList?.map((seatInfo) => {
      if (seatInfo.segmentId !== segId) return seatInfo;
      return {
        ...seatInfo,
        characteristicRequestSsrCode: characteristicRequestSsrCode,
      };
    });
    this.selectedSeatInfoList = newSelectedSeatInfoList;
  }

  /**
   * 表示対象デッキ配列IDの設定
   * @param targetDe  ckType 表示デッキ種別
   */
  initDisplayTargetDeckArrayId(targetDeckType: GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum) {
    // 初期値は0を設定する。「デッキ情報が1件以上、かつ、表示デッキ種別がupper（1階・2階が存在しており、2階が選択されている）」の場合、1を設定する。
    const countDecks: number = this.seatmapResponse?.data.seatmaps.decks.length || 0;
    this.displayTargetDeckArrayId = 0;
    if (countDecks > 1 && targetDeckType === GetSeatmapsResponseDataSeatmapsDecksInner.DeckTypeEnum.Upper) {
      this.displayTargetDeckArrayId = 1;
    }
  }

  /**
   * 対象の座席番号を含むデッキを取得する
   * @param decks 検索対象のデッキ情報配列
   * @param seatNumber 対象の座席番号
   * @returns 取得できた場合：デッキ情報、取得できなかった場合：undefined
   */
  getDeckBySeatNumber(
    decks: Array<GetSeatmapsResponseDataSeatmapsDecksInner> | undefined,
    seatNumber: string
  ): GetSeatmapsResponseDataSeatmapsDecksInner | undefined {
    for (const deck of decks || []) {
      const existsSeatNumber: boolean = !!deck.seats.rows
        .filter((r) => !!r.columns)
        .find((row) => {
          return !!row.columns.filter((c) => !!c.seatNumber).find((c) => c.seatNumber === seatNumber);
        });
      if (existsSeatNumber) {
        return deck;
      }
    }
    return undefined;
  }

  /**
   * スキップセグメント情報リストの初期化
   */
  createSkipSegmentInfoList() {
    // バウンドが存在しない場合スキップ
    if (!this.pnrInfo?.air?.bounds) {
      return;
    }
    let newSkipSegmentInfoList = new Array<SkipSegmentInfo>();
    let boundArrayId = 0;
    this.pnrInfo.air?.bounds?.forEach((bound) => {
      let segmentArrayId = 0;
      bound.flights
        ?.filter((flight) => !!flight?.id)
        .forEach((flight) => {
          let isEligible = this.pnrInfo?.orderEligibilities?.seatmap?.[flight.id!].isEligible;
          // 利用可否が取得できた場合はスキップしないので反転して設定。利用可否が取得できない場合はスキップなしとする。
          newSkipSegmentInfoList.push({
            boundArrayId: boundArrayId,
            segmentArrayId: segmentArrayId,
            segmentId: flight.id!,
            isSkip: isEligible !== undefined ? !isEligible : false,
          });
          segmentArrayId++;
        });
      boundArrayId++;
      segmentArrayId = 0;
    });

    this.__servicingSeatmapStoreService.updateServicingSeatmap({
      skipSegmentInfoList: newSkipSegmentInfoList,
    });
  }
}
